import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Chip,
  Grid,
  Stepper,
  Step,
  useMediaQuery,
  Skeleton,
  Button,
  Tooltip,
  CircularProgress,
  Avatar,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IconButton, UploadButton } from "../../components/ui/Button";
import UploadIcon from "./../../assets/svgIcons/upload.svg";
import ViewIcon from "./../../assets/svgIcons/eye.svg";
import CustomDivider from "../../components/common/CustomDivider";
import LockSquare from "./../../assets/svgIcons/lock-square.svg";
import textFile from "./../../assets/images/icons/file-text.svg";
import ChevronRight from "./../../assets/svgIcons/chevron-right.svg";
import {
  fetchUserApplications,
  fetchUserApplicationsFormData,
} from "../../services/api/service/userApplicationService";
import theme from "../../theme";
import Slider from "react-slick"; // desktop
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "react-multi-carousel";  // mobile
import "react-multi-carousel/lib/styles.css";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DetailRow from "../common-features/DetailRow";
import {
  setCompletedHorizontalIndex,
  setActiveHorizontalIndex,
  setActiveVerticalIndex,
  setIsEligibilityCheckSubmitted,
  setHasCheckedInitialSummary,
  setIsMobileVerified,
  setIsEmailVerified,
  setLastVerifiedEmail,
  setLastVerifiedPhoneNumber,
  updateFormData,
  clearFormData,
  setTrackingId,
  setCollateralId,
  setreferenceOneId,
  setreferenceTwoId,
  setApplicationId,
  setApplicantId,
  setIsDocumentVerified,
  clearActiveIndex,
  setIsPanVerified,
  setPanNumber,
  setAadhaarMandatory,
  setShowAadhaar,
  setHasPan,
  setCoApplicantVerification,
  setBreStatus,
  removeDigiLockerLoaderId,
  clearCoApplicantVerification,
  clearIsDocumentVerifiedCoApplicant,
  clearAadhaarApplicationNoCoApplicant,
  clearAadhaarVerifiedDetailsCoApplicant,
  clearAadhaarVerifiedDetails,
  setLastPanNumber,
  setLeadSequenceId,
  setCheckIsLeadApiInvoked,
  clearSetLoanDetailCoApplicantCollapseValue,
  setAssignedSMIdValue,
  setDisplayHorizontalSteps,
  setDocumentApplicantType,
  setAadhaarSeedingStatus,
  setIsEligible,
  setApplicationSource,
  setDisableAddMoreCoApplicant,
  setSavedBasicForCoApplicant,
  clearSavedBasicCoApplicants,
  clearNotInList,
  setNotInList,
  setCustomerConsentTime,
  setFetchUserApplicationData,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { useDispatch, useSelector } from "react-redux";
import { TruncatedTextWithTooltip } from "../../components/ui/TruncatedTextWithTooltip";
import { Stack } from "@mui/system";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import { formatDateToShortMonth } from "../../utils/dateFormatUtils";
import ApplicationProgressStepper from "../../components/common/ApplicationProgressStepper";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import {
  setChatStatusConfig,
  setCurrentSessionId,
  setSalesUserId,
} from "../../services/redux/slices/chatSlice";
import {
  getCombinedApplicationSteps,
  getGAExistingApplicationStatements,
  getReferenceData
} from "../../components/ui/StepperDyanmicForm/helper";
import { getFormJson } from "../../services/redux/thunks/stepperDynamicFormThunks";
import { AppDispatch, RootState } from "../../services/redux/store";
import { clearAllApplicantLoanDetails, setCoApplicantDetails } from "../../services/redux/slices/applicationLoanDetailsSlice";
import { setHorizontalSteps } from "../../services/redux/slices/stepperDynamicFormSlice";
import DashboardJourny from "./Dashboard";
import {
  setOpenFirstTimeOnlyPopup,
  setAdditionalSummaryActiveTab
} from "../../services/redux/slices/tabsSlice";
import { decrypt } from "../../utils/crypto";
import postsServices from "../../services/api/service/postsService";
import { formatShortMonthWithTime, getApplicationMessage, gotoPageStepOrLoanOverviewPage, isDeviceTypeMobile, normalize,findApplicantStep, getCoApplicantList } from "../../utils/helpers";
import { authSelector,authStatusSelector } from "../../services/redux/slices/authSlice";
import { APP_STATUS, STATUS_MESSAGES } from "../../utils/journeyConstants";
import { InfoOutlined } from "@mui/icons-material";
import { trackCustomerJourneyEvent } from "../../utils/ga";
import CrmIdChip from "../../components/crmChip";
import NextStepBanner from "../../components/ui/NextStepBanner";
import SalesManagerContact from "../../components/ui/SalesManagerContact";

export const checkUndecided = (country: string, universityCountryId: any, source: string, isQualified: boolean, fieldsLength: number) => {
  if(!country && !universityCountryId && (source === "LOS" || source === "CRM" || source === "PARTNER") && isQualified && fieldsLength < 6) {
    return true
  };
  return false;
}

// --- Types ---
interface RecentUpdate {
  id?: string;
  title?: string;
  description?: string;
  timestamp?: string;
}
interface Field {
  [key: string]: any;
}
interface VerticalStep {
  fields: Field[];
}
interface Application {
  horizontalSteps: HorizontalStep[];
  submissionId: string;
  createdAt: string;
  updatedAt: string;
}
interface HorizontalStep {
  horizontalStepName: string;
  verticalStepsCount: number;
  verticalSteps: VerticalStep[];
  completionRate?: number;
}
interface CombinedStep {
  label: string;
  completionRate: number;
  status: "pending" | "completed" | "inprogress";
  isActive: boolean;
  isCompleted: boolean;
  isProvisionalGenerated?: boolean;
  isQualified?: boolean;
  isEligible?: any;
}

/**
 * Determines the active step index (original logic retained, returning 1-based index or -1/total).
 * The active step is the index AFTER the last fully completed step.
 * Returns:
 * - 1 if the very first step is pending.
 * - (Index of last completed step) + 1 if progress has been made.
 * - total steps count if everything is completed.
 *
 * NOTE: The original logic in the component returns a 1-based index or the number of steps.
 * I am keeping this logic for minimum change, but for an MUI Stepper's `activeStep` prop,
 * a 0-based index is typically expected. The consumer (ApplicationProgressStepper) must handle this.
 */
const findActiveStep = (finalSteps: CombinedStep[]): number => {
  for (let i = finalSteps.length - 1; i >= 0; i--) {
    const step = finalSteps[i];
    if (
      step.completionRate === 100 &&
      step.status.toLowerCase() === "completed"
    ) {
      return i + 1;
    }
  }
  return -1;
};

const parseBooleanFlag = (value: any): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.toLowerCase() === "true";
  return false;
};

const normalizeStepName = (value: any): string =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const normalizeCompletionRate = (value: any): number => {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = Number(String(value).replace(/%/g, "").trim());
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

// const isStepCompleted = (step: any): boolean => {
//   const status = String(step?.status || "").toLowerCase();
//   return status === "completed" || normalizeCompletionRate(step?.completionRate) >= 100;
// };
const isStepCompleted = (obj: Record<string, any>): boolean => {
  // If input is missing, not an object, or empty, return false
  if (!obj || typeof obj !== 'object' || Object.keys(obj).length === 0) {
    return false;
  }

  // .every() returns true only if all keys pass the condition
  return Object.values(obj).every((value) => {
    // 1. Check for null or undefined
    if (value === null || value === undefined) {
      return false;
    }

    // 2. Check for empty strings or strings with only blank spaces
    if (typeof value === 'string') {
      return value.trim() !== '';
    }
    // Numbers (like 0) and booleans (like false) are valid filled inputs
    return true;
  });
};

const hasStepFieldData = (step: any): boolean => {
  if (!Array.isArray(step?.fields)) return false;

  return step.fields.some((field: any) =>
    Object.values(field || {}).some((value: any) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return !Number.isNaN(value);
      if (typeof value === "object") {
        if ("value" in value || "label" in value) {
          return String(value?.value ?? value?.label ?? "").trim() !== "";
        }
        return Object.keys(value).length > 0;
      }
      return true;
    }),
  );
};

  
const findLastFilledHorizontalStepIndex = (steps: any[]): number => {
  let lastFilledIndex = -1;
  (steps || []).forEach((step: any, index: number) => {
    if (Array.isArray(step?.verticalSteps) && step.verticalSteps.length > 0) {
      lastFilledIndex = index;
    }
  });
  return lastFilledIndex;
};

const resolveAdditionalDetailsResumeVerticalIndex = (step: any, horizontalData?: any): number => {
  const verticalSteps = Array.isArray(step?.verticalSteps) ? step.verticalSteps : [];
  const horizontalStepsData = horizontalData || []

  const loanDetailsFields = horizontalStepsData?.[1].verticalSteps?.find((vStep: any) => normalizeStepName(vStep?.verticalStepName).includes(normalizeStepName("Co-Applicant Details")))?.fields || [];
  const collateralEntry =
    loanDetailsFields?.find((field: any) =>
      Object.keys(field).some((key) =>
        normalizeStepName(key).includes(normalizeStepName("Collateral"))
      )
    ) || null;

  if (!verticalSteps.length) return 0;

  const fundsStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("fund"),
  );
  const referenceStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("reference"),
  );
  const collateralStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("collateral"),
  );
  const hasAnyAdditionalData =
    hasStepFieldData(fundsStep) ||
    hasStepFieldData(referenceStep) ||
    hasStepFieldData(collateralStep) ||
    isStepCompleted(fundsStep) ||
    isStepCompleted(referenceStep) ||
    isStepCompleted(collateralStep);

  // Helper: check if both sub-sections (1 and 2) of a step have field data
  const hasBothSubSections = (vStep: any, prefix: string): boolean => {
    if (!Array.isArray(vStep?.fields)) return false;
    const allKeys = vStep.fields.flatMap((f: any) => Object.keys(f || {}));
    const hasSection1 = allKeys.some((k: string) =>
      k.toLowerCase().startsWith(`${prefix}1`) && allKeys.find((k2: string) => k2 === k)
        ? String((vStep.fields.find((f: any) => k in f) || {})[k] || "").trim() !== ""
        : false,
    );
    const hasSection2 = allKeys.some((k: string) =>
      k.toLowerCase().startsWith(`${prefix}2`) && allKeys.find((k2: string) => k2 === k)
        ? String((vStep.fields.find((f: any) => k in f) || {})[k] || "").trim() !== ""
        : false,
    );
    return hasSection1 && hasSection2;
  };

  const legacyCollateralValue = (collateralEntry?.collateral ?? "").toString().trim().toLowerCase();
  // "hasCollateral" (inside the Collateral Details step itself) is the current
  // source of truth for whether the applicant has collateral — the old
  // Loan Details "collateral" dropdown read above is only a fallback for
  // applications saved before that field existed.
  const getStepFieldValue = (stepFields: any[] | undefined, fieldNameLower: string): any => {
    if (!Array.isArray(stepFields)) return undefined;
    for (const obj of stepFields) {
      const key = Object.keys(obj || {}).find((k) => k.toLowerCase() === fieldNameLower);
      if (key) return obj[key];
    }
    return undefined;
  };
  const hasCollateralValue = String(
    getStepFieldValue(collateralStep?.fields, "hascollateral") ?? "",
  ).trim().toLowerCase();
  const collateralValue = hasCollateralValue || legacyCollateralValue;

  const referenceFullyFilled =
    isStepCompleted(referenceStep) || hasBothSubSections(referenceStep, "basicreference");
  const collateralFullyFilled =
    // If collateral is "No" or empty, consider it complete
    collateralValue === "no"
      ? true
      : // If collateral is "Yes", validate real collateral fields exist —
        // excluding "hasCollateral" itself, which always matches the
        // "includes collateral" check below but isn't a real collateral field.
        collateralStep?.fields?.some((obj: any) =>
          Object.keys(obj).some((key) =>
            key.toLowerCase() !== "hascollateral" && key.toLowerCase().includes("collateral")
          )
        ) ?? false;
  console.log(collateralFullyFilled,"collateralFullyFilled")
  if (!hasAnyAdditionalData) return 0;
  // If funds step is not completed, land on Fund & Expense page (index 2)
  if (!isStepCompleted(fundsStep)) return 2;
  // If both reference and collateral are fully filled/completed → move to next stage: document & consent (index 4)

  if (referenceFullyFilled && collateralFullyFilled) return 4;
  // Otherwise land on Reference & Collateral page (index 3)
  return 3;
};

const ExistingApplication: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { userProfile } = useSelector(authSelector);
  const isAuthenticated = useSelector(authStatusSelector);
  const [applications, setApplications] = useState<any[]>([]);
  const [selectedAppIndex, setSelectedAppIndex] = useState(0);
  const [isProvisionalOfferExpanded, setIsProvisionalOfferExpanded] =
    useState(false);
  const [isSliderLoading, setIsSliderLoading] = useState(true);
  const [breData, setBreData] = useState<any>({});
  const [isContinueLoading, setIsContinueLoading] = useState(false);
  const [isResumeLoading, setIsResumeLoading] = useState(false);
  const [callbackSnackbar, setCallbackSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "error" | "success";
  }>({ open: false, message: "", severity: "success" });
  // Store lead details response by applicationId
  const [leadDetailsData, setLeadDetailsData] = useState<Record<string, any>>(
    {}
  );
  // Store sanction details response by applicationId
  const [sanctionDetailsData, setSanctionDetailsData] = useState<Record<string, any>>(
    {}
  );
const deviceType = sessionStorage.getItem("deviceType");
  //const isAuthenticated = useSelector(authSelector)?.isAuthenticated;
  const [recentUpdates, setRecentUpdates] = useState<RecentUpdate[]>([]);
  const [isRecentUpdatesLoading, setIsRecentUpdatesLoading] =
    useState<boolean>(false);
  const IsEligible = useSelector((state: RootState) => state.tabs.isEligible);
  const {
    horizontalSteps
  } = useSelector((state: RootState) => state.stepper);
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isIphoneSE = useMediaQuery(`(max-width: 400px)`);
  const reduxHorizontalSteps = useSelector(
    (state: RootState) => state?.stepper?.horizontalSteps
  );

  // Call with (leadId, submissionId)
  const getLeadDetails = async (leadId: string, applicationNumber: string) => {
    const payload = {
      leadId: leadId,
      trackingId: applicationNumber,
    };
    try {
      const res: any = await eligibilityCheckServices.partnerGetLeadDetailsApi(
        payload
      );
      const details = res?.data?.data?.applicationDetails;
      const sanctionDetails = res?.data?.data?.sanctionDetails;
      if (details) {
        const getValue = (list: any[], key: string): string =>
          list.find((item) => item.name === key)?.value ?? "";

        setLeadDetailsData((prev) => ({
          ...prev,
          [applicationNumber]: details,
        }));

        setSanctionDetailsData((prev) => ({
          ...prev,
          [applicationNumber]: sanctionDetails,
        }));
      }
      dispatch(
        setCoApplicantDetails(
          res?.data?.data?.["Co-applicantDetails"]?.["co-applicants"],
        ),
      );
    } catch (e) {
      console.error("getLeadDetails error", e);
    }
  };

  useEffect(() => {
    // Bypass/pre-login users are redirected straight on to apply-now, which
    // prefills form data; a late clearFormData() from here would wipe it.
    let isMounted = true;
    const fetchData = async () => {
      const oldBreData: any = { ...breData };
      setIsSliderLoading(true);
      dispatch(setDisplayHorizontalSteps([]));
      try {
        const token: any = process.env.REACT_APP_FETCH_TOKEN;
        const res: any = await fetchUserApplications(token);
        if (!isMounted) return;
        const apps = res?.data?.applications || [];
        dispatch(clearFormData());
        setApplications(apps.slice(0, 4));
        if (apps.length > 0 && apps[0]?.submissionId) {
          // Prefetch notifications for the first visible application
          fetchLatestNotifications(apps[0]?.submissionId);
        }
        apps.slice(0, 4).forEach((elem: any) => {
          handleBreInvokApi(elem.submissionId, elem, oldBreData);
        });

        // Call getLeadDetails for applications with partnerStartedJourney:true
        for (const app of apps) {
          if (app.partnerStartedJourney && app.leadId && app.submissionId) {
            await getLeadDetails(app.leadId, app.submissionId);
          }
        }
      } catch (e) {
        console.log("fetch existing applications error", e);
      } finally {
        setIsSliderLoading(false);
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  const fetchLatestNotifications = async (trackingId: string) => {
    if (!trackingId) return;
    setIsRecentUpdatesLoading(true);
    try {
      const payload = { trackingId };
      const response = await postsServices.addPost(
        "api/v1/notifications/get-latest-notifications",
        payload
      );
      const encData = response?.data?.data ?? "";
      if (encData) {
        const decrypted = decrypt(encData);
        let jsonData: any = [];
        try {
          jsonData = JSON.parse(decrypted);
        } catch (err) {
          console.error("Failed to parse decrypted notifications JSON", err);
          jsonData = [];
        }
        const mapped: RecentUpdate[] = Array.isArray(jsonData)
          ? jsonData.slice(0, 3).map((item: any, idx: number) => {
            const msg = item?.message ?? item?.title ?? "";
            const short =
              typeof msg === "string" && msg?.length > 60
                ? `${msg.substring(0, 60)}...`
                : msg;
            return {
              id: String(item?.id ?? idx),
              title: short,
              description: msg,
              timestamp: formatShortMonthWithTime(
                item?.created_at ?? item?.timestamp ?? ""
              ),
            } as RecentUpdate;
          })
          : [];
        setRecentUpdates(mapped);
      } else {
        setRecentUpdates([]);
      }
    } catch (error) {
      console.error("latest notifications error", error);
      setRecentUpdates([]);
    } finally {
      setIsRecentUpdatesLoading(false);
    }
  };

  const handleBreInvokApi = async (
    trackingId: string,
    application: any,
    oldBreData: any
  ) => {
    try {
      const payload = {
        applicationId: trackingId,
        name:
          application?.horizontalSteps?.length > 1
            ? "getProvisionalOffer"
            : "getCustomerEligibility",
      };

      const res: any = await eligibilityCheckServices.fetchBreApi(payload);
      oldBreData[trackingId] = res?.data?.data;
      setBreData(oldBreData);
    } catch (e) {
      console.log(e);
    }
  };

  const handleClearData = () => {
    dispatch(setTrackingId(""));
    dispatch(setCollateralId(null));
    dispatch(setreferenceOneId(null));
    dispatch(setreferenceTwoId(null));
    dispatch(setApplicationId(""));
    dispatch(setLeadSequenceId(""));
    dispatch(setCompletedHorizontalIndex(null));
    dispatch(setActiveHorizontalIndex(0));
    dispatch(setActiveVerticalIndex(0));
    dispatch(clearActiveIndex());
    dispatch(clearFormData());
    dispatch(setLastVerifiedPhoneNumber(""));
    dispatch(setLastVerifiedEmail(""));
    dispatch(setIsDocumentVerified(false));
    dispatch(setIsMobileVerified(false));
    dispatch(setIsEmailVerified(false));
    dispatch(setIsPanVerified(false));
    dispatch(setPanNumber(""));
    dispatch(setAadhaarMandatory(false));
    dispatch(setIsEligibilityCheckSubmitted(false));
    dispatch(setShowAadhaar(false));
    dispatch(setHasPan(""));
    dispatch(removeDigiLockerLoaderId());
    localStorage.removeItem("applicationNo");
    dispatch(clearCoApplicantVerification());
    dispatch(clearIsDocumentVerifiedCoApplicant());
    dispatch(clearAadhaarApplicationNoCoApplicant());
    dispatch(clearAadhaarVerifiedDetailsCoApplicant());
    dispatch(clearAadhaarVerifiedDetails());
    dispatch(setLastPanNumber(""));
    dispatch(clearSetLoanDetailCoApplicantCollapseValue());
    dispatch(setAssignedSMIdValue(""));
    dispatch(setSalesUserId(""));
    dispatch(setCurrentSessionId(""));
    dispatch(setOpenFirstTimeOnlyPopup(null));
    dispatch(clearAllApplicantLoanDetails());
    dispatch(setAadhaarSeedingStatus(null));
    dispatch(setIsEligible(false));
    dispatch(setApplicationSource(""));
    dispatch(setDisplayHorizontalSteps([]));
    dispatch(clearSavedBasicCoApplicants())
    dispatch(setChatStatusConfig({}));
  };

  const handleUploadDocument = async () => {
    try {
      trackCustomerJourneyEvent(
        "EXISTINGAPP_UPLOAD DOCUMENT",
        decrypt(userProfile?.id) ?? "",
        applications?.[selectedAppIndex]?.submissionId,
        {
          label: "EXISTINGAPP_UPLOAD DOCUMENT",
          category: "EXISTINGAPP_UPLOAD DOCUMENT",
          action: "EXISTINGAPP_UPLOAD DOCUMENT",
          page: "Existing Application_Upload Document",
        }
      );


      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      const applicationId = applications?.[selectedAppIndex]?.submissionId;
      const collateralId = applications?.[selectedAppIndex]?.collateralId;
      const refrenceone = applications?.[selectedAppIndex]?.referenceOneId;
      const referencetwo = applications?.[selectedAppIndex]?.referenceTwoId;
      const res: any = await fetchUserApplicationsFormData(
        token,
        applicationId
      );

      const apps = res.data?.applications || [];
      const courceCate = apps
        ?.flatMap((app: any) => app.horizontalSteps || [])
        ?.flatMap((h: any) => h.verticalSteps || [])
        ?.flatMap((v: any) => v.fields || [])
        ?.find((f: any) => f.courseCategory)
        ?.courseCategory;
      if (!courceCate) {
        dispatch(
          setStatusPopup({
            status: "info",
            message: "Please Select Course Category ! It is mandatory field.",
          })
        );
        return;
      } else {
        let apiFormData: any = {};
        for (let i = 0; i < apps?.[0]?.horizontalSteps?.length; i++) {
          const verticalSteps = apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
          for (let j = 0; j < verticalSteps?.length; j++) {
            const fields = verticalSteps?.[j]?.fields;
            for (let k = 0; k < fields?.length; k++) {
              const field = fields?.[k];
              apiFormData = { ...apiFormData, ...field };
            }
          }
        }

        dispatch(updateFormData(apiFormData));
        dispatch(setTrackingId(applicationId));
        dispatch(setCollateralId(collateralId));
        dispatch(setreferenceOneId(refrenceone));
        dispatch(setreferenceTwoId(referencetwo));
        navigate("/application/upload-document");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleInvokeLeadApiData = (apps: any) => {
    dispatch(setTrackingId(apps?.submissionId));
    dispatch(setApplicationId(apps?.applicationId));
    dispatch(setApplicantId(apps?.applicantId));
    dispatch(setLeadSequenceId(apps?.leadId));
    dispatch(setAssignedSMIdValue(apps?.assignedSMId));

    dispatch(
      setCheckIsLeadApiInvoked({
        key: "ASSIGN_SM",
        value: apps?.assignedSMId ? true : false,
      })
    );
    dispatch(
      setCheckIsLeadApiInvoked({
        key: "CREATE_LEAD",
        value: apps?.assignedSMId && apps?.leadId ? true : false,
      })
    );
    dispatch(
      setCheckIsLeadApiInvoked({
        key: "LEAD_TO_APPLICATION",
        value:
          apps?.applicantId &&
            apps?.applicationId &&
            apps?.applicationDisplayCode
            ? true
            : false,
      })
    );
  };

  const extractCoApplicantKeys = (fields: any[]) => {
    const coApplicantSet = new Set<string>();

    fields.forEach((field) => {
      const match = field.name?.match(/CoApplicant(\d+)/);
      if (match?.[1]) {
        coApplicantSet.add(`CoApplicant${match[1]}`);
      }
    });

    return Array.from(coApplicantSet); // ["CoApplicant1", "CoApplicant2"]
  };

  // Extract co-applicant keys from fetched form data objects (no name property)
  const extractCoApplicantKeysFromData = (fieldObjects: any[]) => {
    const coApplicantSet = new Set<string>();
    fieldObjects?.forEach((obj: any) => {
      Object.keys(obj || {}).forEach((key) => {
        const match = key.match(/CoApplicant(\d+)/);
        if (match?.[1]) {
          coApplicantSet.add(`CoApplicant${match[1]}`);
        }
      });
    });
    return Array.from(coApplicantSet);
  };

  /**
   * Handles the "Continue" action for an existing application.
   *
   * - Clears previous form data and resets eligibility check state.
   * - Fetches the latest application form data using the provided token and selected application ID.
   * - Updates Redux state with tracking ID, active step indices, and form data.
   * - Extracts and dispatches verification status for phone number, email, and co-applicant details.
   * - Navigates the user to the application form page.
   *
   * @async
   * @returns {Promise<void>} Resolves when the process is complete.
   */
  // --------- please make sure you are adding similar changes to function inside of ViewAllApplications.tsx file
  const handleContinue = async (selectedApp: any, showContinueLoader = true) => {
    dispatch(setHasCheckedInitialSummary(false));
    dispatch(setAdditionalSummaryActiveTab(0));
    // Clear any Documents/Consent tab choice persisted from a previous visit to the
    // Additional Summary step, so re-entering fresh via Continue/Resume always starts
    // on Documents instead of restoring a stale choice.
    if (selectedApp?.submissionId) {
      localStorage.removeItem(`additionalSummaryActiveTab:${selectedApp.submissionId}`);
    }
    if (selectedApp?.assistedJourneyRequired) {
      dispatch(
        setStatusPopup({
          status: "info",
          message:
            "You have already started your journey with a partner. Please complete your journey with the partner.",
        })
      );
      return;
    } else {
      if (showContinueLoader) {
        setIsContinueLoading(true);
      }
      try {
        dispatch(setIsEligibilityCheckSubmitted(false));
        handleClearData();


        const breObj = breData?.[selectedApp?.submissionId];
        // Consider blank if all values are empty string, null, or undefined
        const isBlankObject =
          breObj &&
          Object.keys(breObj).length > 0 &&
          Object.values(breObj).every(
            (v) => v === "" || v === null || v === undefined
          );

        if (isBlankObject) {
          dispatch(setBreStatus("FROM_FORM"));
        } else {
          dispatch(setBreStatus("FROM_APPLICATION"));
        }
        try {
          const token: any = process.env.REACT_APP_FETCH_TOKEN;
          const applicationId = applications?.[selectedAppIndex]?.submissionId;
          await dispatch(getFormJson({ product: "SLI", trackingId: applicationId }));
          const res: any = await fetchUserApplicationsFormData(
            token,
            applicationId
          );
          const apps = res.data?.applications || [];

          // Sync the freshly-fetched application into fetchUserApplicationData so
          // isDIYJourney (partnerStartedJourney-derived) reflects THIS application
          // instead of whatever was left over from a previously viewed one.
          if (apps?.[0]) {
            dispatch(setFetchUserApplicationData(apps[0]));
          }

          dispatch(setLeadSequenceId(apps?.[0]?.leadId || ""));
          const applicationSource = apps?.[0]?.source || "";
          trackCustomerJourneyEvent(
            `${getGAExistingApplicationStatements(applicationSource)}_EXISTINGAPP_CONTINUE`,
             decrypt(userProfile?.id) ?? "",
            applications?.[selectedAppIndex]?.submissionId,
            {
              label: `${getGAExistingApplicationStatements(applicationSource)}_EXISTINGAPP_CONTINUE`,
              category: `${getGAExistingApplicationStatements(applicationSource)}_EXISTINGAPP_CONTINUE`,
              action: `${getGAExistingApplicationStatements(applicationSource)}_EXISTINGAPP_CONTINUE`,
              page: "Existing Application Continue",
            }
          );

          const verticalSteps = apps?.[0]?.horizontalSteps?.[0]?.verticalSteps;
          const filterCourseData = Array.isArray(verticalSteps)
            ? verticalSteps.find((elem: any) => elem?.verticalStepName === "Provide Course Details")
            : undefined;

          if (filterCourseData) {
            // Sync notInList to Redux from fetched course-details (universityNotInList, instituteNotInList, courseNameNotInList)
            const fields = filterCourseData?.fields || [];
            const getFieldValue = (key: string) => {
              const obj = fields.find((f: any) => f && key in f);
              return obj ? String(obj[key]).toLowerCase() : "";
            };
            dispatch(clearNotInList());
            if (getFieldValue("universityNotInList") === "true") dispatch(setNotInList("University Name"));
            if (getFieldValue("instituteNotInList") === "true") dispatch(setNotInList("Institute Name"));
            if (getFieldValue("courseNameNotInList") === "true") dispatch(setNotInList("Course Name"));
          }

          // Prefer fetched application data to drive first-time correctness
          const fetchedApplicantLoanStep = apps?.[0]?.horizontalSteps?.find(
            (step: any) =>
              step.horizontalStepName === "Applicant & Loan Details"
          );

          const fetchedLoanDetailsStep = fetchedApplicantLoanStep?.verticalSteps?.find(
            (vStep: any) => vStep.verticalStepName === "Co-Applicant Details"
          );

          if (fetchedLoanDetailsStep?.fields) {
            // 1) Mark co-applicant basics as saved based on fetched data
            const coApplicantKeysFromData = extractCoApplicantKeysFromData(
              fetchedLoanDetailsStep.fields || [],
            );
            coApplicantKeysFromData.forEach((coAppKey) => {
              dispatch(
                setSavedBasicForCoApplicant({
                  coAppKey,
                  value: true,
                }),
              );
            });

            // 2) Build fetched isEmployed keys set
            const fetchedIsEmployedFields = new Set<string>();
            fetchedLoanDetailsStep.fields.forEach((field: any) => {
              Object.keys(field || {}).forEach((key) => {
                if (
                  /^employmentCoApplicant\d+isEmployed$/.test(key) &&
                  field[key] &&
                  field[key] !== ""
                ) {
                  fetchedIsEmployedFields.add(key);
                }
              });
            });

            // 3) If Redux schema is available, compare and potentially disable add more
            if (reduxHorizontalSteps && Array.isArray(reduxHorizontalSteps)) {
              const reduxApplicantLoanStep = reduxHorizontalSteps.find(
                (step: any) => step.stepLabel === "Applicant & Loan Details",
              );
              const reduxLoanDetailsStep =
                reduxApplicantLoanStep?.verticalSteps?.find(
                  (vStep: any) => vStep.stepLabel === "Co-Applicant Details",
                );
              const reduxIsEmployedFields = (reduxLoanDetailsStep?.fields || [])
                .map((field: any) => field.name)
                .filter((name: string) =>
                  /^employmentCoApplicant\d+isEmployed$/.test(name),
                );

              if (reduxIsEmployedFields.length > 0) {
                const missingFields = reduxIsEmployedFields.filter(
                  (fieldName: string) =>
                    !fetchedIsEmployedFields.has(fieldName),
                );
                if (missingFields.length > 0) {
                  dispatch(setDisableAddMoreCoApplicant(true));
                }
              }
            }
          }

          dispatch(setApplicationSource(apps?.[0]?.source || ""));

          handleInvokeLeadApiData(apps?.[0]);
          dispatch(setAadhaarSeedingStatus(apps?.[0]?.isAadhaarSeeded));

          // const courceCate =
          //   apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.[0]
          //     ?.courseCategory;

          // if (!courceCate) {
          //   dispatch(
          //     setStatusPopup({
          //       status: "info",
          //       message:
          //         "Please Select Cource Category ! It is mandatory field.",
          //     })
          //   );
          //   return;
          // }

          // setting firsttime view only popup flags which will get displayed in summary page
          dispatch(
            setOpenFirstTimeOnlyPopup({
              isSanctionedPopupViewed: apps[0]?.SanctionedPopUp,
              isDisbursedPopupViewed: apps[0]?.DisbursementPopUp,
              isConnectWithSalesPopupViewed: apps[0]?.ConnectWithSalesPopUp,
            })
          );

          // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
          dispatch(setSalesUserId(res?.data?.applications?.[0]?.assignedSMId));

          // Clear display horizontal steps before setting new data
          dispatch(setDisplayHorizontalSteps([]));

          // Add small delay to ensure clearing is processed before setting new data
          await new Promise(resolve => setTimeout(resolve, 50));

          // this logic is for getting customized array of horizontalsteps
          let finalSteps: any[] = [];
          for (let i = 0; i < apps.length; i++) {
            const element = apps[i];
            //finalSteps = getCombinedApplicationSteps(element);
          }
          //dispatch(setDisplayHorizontalSteps(finalSteps));
          const data = filterCourseData?.fields?.find((f: any) => f.admissionStatus?.toLowerCase() === "undecided");
          const country = filterCourseData?.fields?.find((f: any) => f.country)?.country;
          const universityCountryId = filterCourseData?.fields?.find((f: any) => f.universityCountryId)?.universityCountryId;
          const isValid = checkUndecided(country, universityCountryId, applicationSource, apps?.[0]?.isQualified, apps[0]?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.length);

          if (data && isValid) {
              dispatch(setActiveHorizontalIndex(0));
              dispatch(setActiveVerticalIndex(1));
          } else {
          if (
            apps?.[0] &&
            apps?.[0]?.isQualified === true &&
            apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length === 3 &&
            apps?.[0]?.horizontalSteps?.[1].completionRate != 100 // if first two steps are 100% completed it means User shouldnt navigate to forms
          ) {
            const findVerticalStepLength = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length === 0 ? 0 :
              apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length - 1;
            const horizontalStepsData = apps?.[0]?.horizontalSteps || [];
            const lastFilledHorizontalIndex = findLastFilledHorizontalStepIndex(horizontalStepsData);
            const additionalDetailsIndex = horizontalStepsData.findIndex(
              (step: any) =>
                normalizeStepName(step?.horizontalStepName) ===
                normalizeStepName("Additional Details & Documents"),
            );
            const data = horizontalStepsData.find(
              (step: any) =>
                normalizeStepName(step?.horizontalStepName) ===
                normalizeStepName("Additional Details & Documents"),
            );
           if (horizontalSteps[0]?.verticalSteps[1]?.fields?.length > apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.length) {
              
              dispatch(
                setActiveVerticalIndex(
                  apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length - 2
                )
              );
              dispatch(
                setActiveHorizontalIndex(0)
              );
            } else if (lastFilledHorizontalIndex === additionalDetailsIndex) {
              dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
              if(findApplicantStep(data)===true && (data?.verticalSteps?.length===1 || data?.verticalSteps?.length===2)){
                dispatch(
                  setActiveVerticalIndex(1),
                )
              }else{
                const totalRefNo = await getReferenceData(apps?.[0]?.submissionId)
                if(totalRefNo===1){
                  dispatch(
                    setActiveVerticalIndex(3),
                  )
                }else{
                  dispatch(
                    setActiveVerticalIndex(
                      resolveAdditionalDetailsResumeVerticalIndex(
                        horizontalStepsData?.[additionalDetailsIndex],
                        horizontalStepsData
                      ),
                    ),
                  );
                }
                
              }
            }
            else {
             
              if(apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length===2 && apps?.[0]?.horizontalSteps?.[1]?.verticalSteps
              ?.find((step:any) => step?.verticalStepName === "Co-Applicant Details") && apps?.[0]?.horizontalSteps?.[1]?.verticalSteps
              ?.find((step:any) => step?.verticalStepName === "Student Details")?.fields?.length === 4){
                dispatch(setActiveHorizontalIndex(1));
                dispatch(setActiveVerticalIndex(0));

              }else{
                if(apps?.[0]?.isProvisionalGenerated===true){
                  dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                  dispatch(
                    setActiveVerticalIndex(
                      resolveAdditionalDetailsResumeVerticalIndex(
                        horizontalStepsData?.[additionalDetailsIndex],
                        horizontalStepsData
                      ),
                    ),
                  );
                }else{
                  dispatch(setActiveHorizontalIndex(1));
                  dispatch(setActiveVerticalIndex(findVerticalStepLength));
                }
                
              }

            }
          } else {
            dispatch(setTrackingId(apps?.[0]?.submissionId || ""));
            dispatch(setCollateralId(apps?.[0]?.collateralId || null));
            dispatch(setreferenceOneId(apps?.[0]?.referenceOneId || null));
            dispatch(setreferenceTwoId(apps?.[0]?.referenceTwoId || null));
            const horizontalStepsData = apps?.[0]?.horizontalSteps || [];
            const lastFilledHorizontalIndex = findLastFilledHorizontalStepIndex(
              horizontalStepsData,
            );
            const additionalDetailsIndex = horizontalStepsData.findIndex(
              (step: any) =>
                normalizeStepName(step?.horizontalStepName) ===
                normalizeStepName("Additional Details & Documents"),
            );
            const filledHorizontalSteps = horizontalStepsData.filter(
              (elem: any) => elem?.verticalSteps?.length > 0,
            );
            const findActiveHorizontalIndex =
              apps?.[0]?.horizontalSteps?.filter(
                (elem: any) => elem?.verticalSteps?.length > 0
              );
              const data = horizontalStepsData.find(
                (step: any) =>
                  normalizeStepName(step?.horizontalStepName) ===
                  normalizeStepName("Additional Details & Documents"),
              );
              
              if (horizontalSteps[0]?.verticalSteps[1]?.fields?.length > apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.length) {
               dispatch(
                setActiveVerticalIndex(
                  apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length - 2
                )
              );
              dispatch(
                setActiveHorizontalIndex(0)
              );
            }else if (lastFilledHorizontalIndex === additionalDetailsIndex) {
              dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
              if(findApplicantStep(data)===true  &&  (data?.verticalSteps?.length===1 || data?.verticalSteps?.length===2) ){
                dispatch(
                  setActiveVerticalIndex(1),
                )
              }else{
                const totalRefNo = await getReferenceData(apps?.[0]?.submissionId)
                if(totalRefNo===1){
                  dispatch(
                    setActiveVerticalIndex(3),
                  )
                }else{
                  dispatch(
                    setActiveVerticalIndex(
                      resolveAdditionalDetailsResumeVerticalIndex(
                        horizontalStepsData?.[additionalDetailsIndex],
                        horizontalStepsData
                      ),
                    ),
                  );
                }
              }
            }
            else if (
              additionalDetailsIndex !== -1 &&
              lastFilledHorizontalIndex > additionalDetailsIndex
            ) {
              // Application already progressed past Additional Details &
              // Documents (e.g. Summary/Loan Summary was already reached) —
              // resume at its last real step (Document & Consent) instead of
              // falling through to the stepper-index heuristics below, which
              // assume no step after Additional Details ever has data.
              dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
              dispatch(setActiveVerticalIndex(4));
            }
            else if (apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
              ]?.verticalSteps?.length <=  6 && apps?.[0]?.isProvisionalGenerated===true) {
                
                dispatch(setActiveHorizontalIndex(3));
                dispatch(setActiveVerticalIndex(0));
              }
            else if (
              findActiveHorizontalIndex.length - 1 == 1 &&
              apps?.[0]?.horizontalSteps?.[findActiveHorizontalIndex.length - 1]
                ?.verticalSteps?.length == 6
            ) {
              // Find the 'Loan Details' vertical step
              const loanDetailsStep = apps?.[0]?.horizontalSteps?.[
                findActiveHorizontalIndex.length - 1
              ]?.verticalSteps?.find(
                (step: any) => step.verticalStepName === "Co-Applicant Details"
              );
              // Check for LoanDetailsLoanAmount and collateral fields with values
              const hasLoanDetails =
                loanDetailsStep &&
                Array.isArray(loanDetailsStep.fields) &&
                loanDetailsStep.fields.some(
                  (f: any) =>
                    f.LoanDetailsLoanAmount && f.LoanDetailsLoanAmount !== ""
                ) &&
                loanDetailsStep.fields.some(
                  (f: any) => f.collateral && f.collateral !== ""
                );

              if (hasLoanDetails) {
                // Dynamically check for any field key that includes 'basic', 'address', or 'employment'
                const fieldKeyPatterns = ["basic", "address", "employment"];
                const hasOtherFields = fieldKeyPatterns.every((pattern) =>
                  loanDetailsStep.fields.some((f: any) =>
                    Object.keys(f).some(
                      (key) =>
                        key.toLowerCase().includes(pattern) &&
                        f[key] &&
                        f[key] !== ""
                    )
                  )
                );

                if (!isBlankObject && hasOtherFields) {
                  dispatch(setActiveHorizontalIndex(3));
                  dispatch(setActiveVerticalIndex(0));
                } else {
                  dispatch(setActiveHorizontalIndex(2));
                  dispatch(setActiveVerticalIndex(0));
                }
              } else {
                dispatch(
                  setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
                );
                dispatch(setActiveVerticalIndex(5));
              }
            } else {
              dispatch(
                setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
              );
              if (findActiveHorizontalIndex.length === 1 && apps?.[0]?.isProvisionalGenerated===false) {
                
                dispatch(
                  setActiveVerticalIndex(
                    apps?.[0]?.horizontalSteps?.[
                      findActiveHorizontalIndex.length - 1
                    ]?.verticalSteps?.length
                  )
                );
                

              } else {
                let filterveritical = apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.find(
                  (step: any) => step?.verticalStepName === "Co-Applicant Details"
                );
                const count = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.filter((item: any) => {
                  const value = Object.values(item)[0];
                  return value !== "" && value !== null && value !== undefined;
                }).length;
                // const isSingleVerticalStep = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length === 1;
                const minimumCount =  13;
                
                if (count < minimumCount)  {
                  dispatch(
                    setActiveVerticalIndex(0)
                  );
                } else if (apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.length <= 6 && apps?.[0]?.isProvisionalGenerated===true) {
                  
                    dispatch(setActiveHorizontalIndex(3));
                    dispatch(setActiveVerticalIndex(0));
                  

                }else if (apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.length != 6 && filterveritical?.verticalStepName === "Co-Applicant Details") {
                  dispatch(
                    setActiveVerticalIndex(
                      apps?.[0]?.horizontalSteps?.[
                        findActiveHorizontalIndex.length - 1
                      ]?.verticalSteps?.length - 1
                    )
                  );

                }  else {
                  dispatch(
                    setActiveVerticalIndex(
                      apps?.[0]?.horizontalSteps?.[
                        findActiveHorizontalIndex.length - 1
                      ]?.verticalSteps?.length
                    )
                  );

                }

              }
            }
            dispatch(
              setCompletedHorizontalIndex(findActiveHorizontalIndex.length - 1)
            );
          }
        }

          const lengthOfHorizontalSteps = apps?.[0]?.horizontalSteps?.length;
          let apiFormData: any = {};
          for (let i = 0; i < lengthOfHorizontalSteps; i++) {
            const verticalSteps =
              apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
            for (let j = 0; j < verticalSteps?.length; j++) {
              const fields = verticalSteps?.[j]?.fields;
              for (let k = 0; k < fields?.length; k++) {
                const field = fields?.[k];
                apiFormData = { ...apiFormData, ...field };
              }
            }
          }
          dispatch(setIsPanVerified(Boolean(apiFormData?.isPanVerified)));
          if (lengthOfHorizontalSteps >= 2) {
            dispatch(setIsEligibilityCheckSubmitted(true));
          }
          dispatch(setLastVerifiedPhoneNumber(apiFormData?.phone_number));
          dispatch(setLastVerifiedEmail(apiFormData?.email));
          dispatch(
            setIsMobileVerified(apiFormData?.phone_number ? true : false)
          );
          dispatch(setIsEmailVerified(apiFormData?.email ? true : false));
          dispatch(updateFormData(apiFormData));
          /**
           * Iterates over all fields in the fetched application form data.
           * For each co-applicant PAN, email, and phone field:
           *    - Extracts the co-applicant index and field type using regex.
           *    - Builds a verification object indicating whether each field is verified and stores the last verified value.
           *    - Dispatches the verification status to Redux for each co-applicant.
           * This ensures the UI can correctly display "Verified" status for each co-applicant's PAN, email, and phone fields.
           */
          Object.entries(apiFormData).forEach(([key, value]) => {
            const match = key.match(
              /^coApplicant(\d+)(PanNumber|Email|Phone_number)$/
            );
            if (match) {
              const idx = Number(match[1]) - 1; // usually index starts from 0
              const type = match[2];
              let verification: any = {};
              if (type === "PanNumber") {
                verification.panVerified = !!value;
                verification.lastPanNumber = value;
              }
              if (type === "Email") {
                verification.emailVerified = !!value;
                verification.lastVerifiedEmail = value;
              }
              if (type === "Phone_number") {
                verification.mobileVerified = !!value;
                verification.lastVerifiedMobileNumber = value;
              }
              dispatch(
                setCoApplicantVerification({
                  index: String(idx),
                  data: verification,
                })
              );
            }
          });
          // Call checkOffer API if isQualified is false
          if (apps?.[0] && apps?.[0]?.isQualified === false && apps?.[0]?.horizontalSteps[0]?.verticalSteps.length === 3 && apps?.[0]?.horizontalSteps[1]?.verticalSteps.length === 0) {
            try {
              const payload = {
                applicationId: apps?.[0]?.submissionId,
                name: "getCustomerEligibility",
              };

              const res: any = await eligibilityCheckServices.fetchBreApi(payload);
              if (res?.data?.data?.Scheme_Available !== "Yes" && res?.data?.data?.Scheme_Available !== "No") {
                const brePayload = {
                  applicationId: apps?.[0]?.submissionId,
                  provisionalOfferBody: {
                    values: {
                      input: {
                        Unique_Lead_ID: apps?.[0]?.submissionId,
                        oApplicant: {
                          oApplName: {
                            sFirstName: apiFormData?.firstName || "",
                            sLastName: apiFormData?.lastName || "",
                          },
                          aCourseDetails: [
                            {
                              ...(apiFormData?.instituteNotInList === "false" && {
                                institute_code: apiFormData?.institute_code || "",
                              }),
                              ...(apiFormData?.courseNameNotInList === "false" && {
                                course_code: apiFormData?.courseCode || "",
                              }),
                              ...(apiFormData?.universityNotInList === "false" && {
                                university_campus_id:
                                  apiFormData?.universityCampusId || "",
                              }),
                              category: apiFormData?.courseType || "",
                              admission_status:
                                apiFormData?.admissionStatus || "",
                              course_category: apiFormData?.courseCategory || "",
                            },
                          ],
                        },
                      },
                    },
                  },
                };

                const breResp = await eligibilityCheckServices.checkOffer(
                  brePayload
                );
              }
              //dispatch(setBreData(breResp?.data?.data));
            } catch (error) {
              console.error("CheckOffer API call failed:", error);
              dispatch(setIsEligible(false));
            }
          }
          dispatch(
            setIsMobileVerified(
              parseBooleanFlag(apiFormData?.isMobileVerified),
            ),
          );
          dispatch(
            setIsEmailVerified(parseBooleanFlag(apiFormData?.isEmailVerified)),
          );
          const isLoanOverview = await gotoPageStepOrLoanOverviewPage(selectedApp?.submissionId);
          const additionalStep=apps?.[0]?.horizontalSteps?.find((step:any) =>
            /Additional\s*(Details|Document)/i.test(step.horizontalStepName || "")
          );
          const checkAllFilled = additionalStep.verticalSteps?.find((vStep:any) =>
            /Reference.*Details/i.test(vStep.verticalStepName || "")
          );
          const collateral = additionalStep.verticalSteps?.find((vStep:any) =>
            /Collateral.*Details/i.test(vStep.verticalStepName || "")
          );
          if(isLoanOverview && checkAllFilled?.verticalStepName==="Reference Details" && collateral?.verticalStepName==="Collateral Details"){ 
            navigate("/application/loan-summary");
          } else {
            navigate("/application/apply-now");
          }
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      } finally {
        if (showContinueLoader) {
          setIsContinueLoading(false);
        }
      }
    }

    // navigate("/stepper")
  };

  // --------- please make sure you are adding similar changes to function inside of ViewAllApplications.tsx file
  const handleViewSummary = async () => {
    trackCustomerJourneyEvent(
      "EXISTINGAPP_VIEWSUMMARY",
      decrypt(userProfile?.id) ?? "",
      applications?.[selectedAppIndex]?.submissionId,
      {
        label: "EXISTINGAPP_VIEWSUMMARY",
        category: "EXISTINGAPP_VIEWSUMMARY",
        action: "EXISTINGAPP_VIEWSUMMARY",
        page: "Existing Application_View Summary",
      }
    );

    dispatch(setDisplayHorizontalSteps([]));
    dispatch(setIsEligibilityCheckSubmitted(false));
    dispatch(setDocumentApplicantType(""));
    handleClearData();

    dispatch(setBreStatus("FROM_APPLICATION"));

    try {
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      const applicationId = applications?.[selectedAppIndex]?.submissionId;
      const res: any = await fetchUserApplicationsFormData(
        token,
        applicationId
      );
      const apps = res.data?.applications || [];
      let count = 0;

      //const courceCate = apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.find((elem: any) => elem.courseCategory)?.courseCategory;
      const courceCate = apps
        ?.flatMap((app: any) => app.horizontalSteps || [])
        ?.flatMap((h: any) => h.verticalSteps || [])
        ?.flatMap((v: any) => v.fields || [])
        ?.find((f: any) => f.courseCategory)
        ?.courseCategory;
      if (!courceCate) {
        dispatch(
          setStatusPopup({
            status: "info",
            message: "Please Select Course Category ! It is mandatory field.",
          })
        );
        return;
      }

      // setting firsttime view only popup flags which will get displayed in summary page
      dispatch(
        setOpenFirstTimeOnlyPopup({
          isSanctionedPopupViewed: apps[0]?.SanctionedPopUp,
          isDisbursedPopupViewed: apps[0]?.DisbursementPopUp,
          isConnectWithSalesPopupViewed: apps[0]?.ConnectWithSalesPopUp,
        })
      );

      // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
      dispatch(setSalesUserId(res?.data?.applications?.[0]?.assignedSMId));
      // store customerConsentTime from fetched application
      dispatch(setCustomerConsentTime(apps?.[0]?.customerConsentTime!=null ? true : false));

      // this logic is for getting customized array of horizontalsteps
      let finalSteps: any[] = [];
      for (let i = 0; i < apps.length; i++) {
        const element = apps[i];
        //finalSteps = getCombinedApplicationSteps(element);
        //count = finalSteps.filter((val) => val.status === "completed").length;
      }
      //dispatch(setDisplayHorizontalSteps(finalSteps));

      dispatch(setTrackingId(apps?.[0]?.submissionId || ""));
      dispatch(setCollateralId(apps?.[0]?.collateralId || null));
      dispatch(setreferenceOneId(apps?.[0]?.referenceOneId || null));
      dispatch(setreferenceTwoId(apps?.[0]?.referenceTwoId || null));
      const lengthOfHorizontalSteps = apps?.[0]?.horizontalSteps?.length;
      dispatch(setActiveHorizontalIndex(lengthOfHorizontalSteps - 1));
      dispatch(
        setActiveVerticalIndex(
          apps?.[0]?.horizontalSteps?.[lengthOfHorizontalSteps - 1]
            ?.verticalSteps?.length
        )
      );

      let apiFormData: any = {};

      for (let i = 0; i < lengthOfHorizontalSteps; i++) {
        const verticalSteps = apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
        for (let j = 0; j < verticalSteps?.length; j++) {
          const fields = verticalSteps?.[j]?.fields;
          for (let k = 0; k < fields?.length; k++) {
            const field = fields?.[k];
            apiFormData = { ...apiFormData, ...field };
          }
        }
      }

      dispatch(setLastVerifiedPhoneNumber(apiFormData?.phone_number));
      dispatch(setLastVerifiedEmail(apiFormData?.email));
      dispatch(setIsMobileVerified(apiFormData?.phone_number ? true : false));
      dispatch(setIsEmailVerified(apiFormData?.email ? true : false));
      dispatch(updateFormData(apiFormData));

      // /**
      //  * Iterates over all fields in the fetched application form data.
      //  * For each co-applicant PAN, email, and phone field:
      //  *   - Extracts the co-applicant index and field type using regex.
      //  *   - Builds a verification object indicating whether each field is verified and stores the last verified value.
      //  *   - Dispatches the verification status to Redux for each co-applicant.
      //  * This ensures the UI can correctly display "Verified" status for each co-applicant's PAN, email, and phone fields.
      //  */
      Object.entries(apiFormData).forEach(([key, value]) => {
        const match = key.match(
          /^coApplicant(\d+)(PanNumber|Email|Phone_number)$/
        );
        if (match) {
          const idx = Number(match[1]) - 1; // usually index starts from 0
          const type = match[2];
          let verification: any = {};
          if (type === "PanNumber") {
            verification.panVerified = !!value;
            verification.lastPanNumber = value;
          }
          if (type === "Email") {
            verification.emailVerified = !!value;
            verification.lastVerifiedEmail = value;
          }
          if (type === "Phone_number") {
            verification.mobileVerified = !!value;
            verification.lastVerifiedMobileNumber = value;
          }
          dispatch(
            setCoApplicantVerification({
              index: String(idx),
              data: verification,
            })
          );
        }
      });

      if (lengthOfHorizontalSteps > 0) {
        dispatch(setIsEligibilityCheckSubmitted(true));
        dispatch(setCompletedHorizontalIndex(count - 1));
        dispatch(setActiveHorizontalIndex(3));
      }

      dispatch(setCompletedHorizontalIndex(count - 1));

      navigate("/application/summary");
    } catch (e) {
      console.log(e);
    }
  };

  const handleResumeApplication = async (selectedApplication: any) => {
    setIsResumeLoading(true);
    try {
      if (selectedApplication?.partnerStartedJourney) {
        await handleViewSummary();
      } else {
        await handleContinue(selectedApplication, false);
      }
    } finally {
      setIsResumeLoading(false);
    }
  };

  const viewAll = () => {
    trackCustomerJourneyEvent(
      "Postlogin_Viewallapplications",
      decrypt(userProfile?.id) ?? "",
      "",
      {
        label: "Postlogin_Viewallapplications",
        category: "Postlogin_Viewallapplications",
        action: "Postlogin_Viewallapplications",
        page: "Post Login View All Application",
      }
    );
    navigate("/application/view-all-applications");
  };

  // Carousel settings
  let maxDots = 4;
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: selectedAppIndex,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    afterChange: (current: number) => {
      setSelectedAppIndex(current);
      const trackingId = applications?.[current]?.submissionId;
      if (trackingId) {
        fetchLatestNotifications(trackingId);
      }
    },
    customPaging: (i: number) => (
      <Box
        sx={{
          width: 12,
          height: 12,
          border: "none",
          borderRadius: "50%",
          bgcolor: i === selectedAppIndex ? "#00b3b5" : "#ccc",
          cursor: "pointer",
          transition: "all 0.2s",
          opacity: i < maxDots ? 1 : 0,
          pointerEvents: i < maxDots ? "auto" : "none",
        }}
      />
    ),
    dotsClass: "slick-dots custom-dots",
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2.5, // Show 2.5 items to make second card partially visible
      slidesToSlide: 1, // Change to 1 for single-click sliding
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1.8, // Show 1.8 items to make second card partially visible
      slidesToSlide: 1, // Change to 1 for single-click sliding
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <Grid
      className="existing-application"
      spacing={2}
      style={{ paddingBottom: isXsOrSm ? "88px" : undefined }}
    >
      {isXsOrSm ? <></> : <DashboardJourny activeTab={"existing"} />}

    <Box sx={{ml: isDeviceTypeMobile(isXsOrSm)?1.6:0, mr: isDeviceTypeMobile(isXsOrSm)?1:0}}>

      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: isXsOrSm && deviceType=="mobile" ? 10 : 0, }}
      >
        <Typography
          className="section-heading"
          sx={{ 
            fontSize: isXsOrSm ? "15px !important" : "",
            ml: isDeviceTypeMobile(isXsOrSm) ? 0 : 0
          }}
        >
          Applications
        </Typography>
        <Typography
          className="section-heading"
          onClick={viewAll}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontSize: isXsOrSm ? "14px !important" : "",
            fontWeight: isXsOrSm ? "400 !important" : 600,
            mr: isDeviceTypeMobile(isXsOrSm) || isXsOrSm ? 1 : 0,
          }}
        >
          View all Applications{" "}
          <img
            src={ChevronRight}
            alt="Chevron Right"
            style={{ marginLeft: "5px" }}
          />
        </Typography>
      </Box>

      {isXsOrSm ? (
        isSliderLoading ? (
          <Box
            sx={{
              margin: "0 auto",
              width: "100%",
              // maxWidth: "min(95vw, 380px)",
              overflowX: "hidden",
            }}
          >
            <Box
              sx={{
                border: "1px solid rgba(215, 216, 222, 1)",
                borderRadius: "16px",
                p: 2,
                boxSizing: "border-box",
              }}
            >
              {/* Top Section: Title, Chip, and Buttons */}
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap={1.5}
                mb={2}
              >
                {/* Title and Chip */}
                <Box display="flex" alignItems="center" gap={1} flexShrink={1}>
                  <Skeleton variant="text" width={180} height={28} />
                  <Skeleton
                    variant="rectangular"
                    width={70}
                    height={20}
                    sx={{ borderRadius: "16px" }}
                  />
                </Box>
                {/* Action Buttons */}
                <Stack
                  direction="row"
                  spacing={1.5}
                  justifyContent="flex-start"
                  flexWrap="wrap"
                >
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                </Stack>
              </Box>

              <Skeleton
                variant="rectangular"
                width="100%"
                height={1}
                sx={{ my: 2 }}
              />

              {/* Application Details Section */}
              <Box sx={{ my: 2, textAlign: "left" }}>
                <Skeleton
                  variant="text"
                  width={150}
                  height={20}
                  sx={{ mb: 2 }}
                />
                <Grid container rowSpacing={2} columnSpacing={2}>
                  {Array.from({ length: 4 }).map((_, index) => (
                    <Grid item xs={6} key={index}>
                      <Skeleton variant="text" width="70%" height={16} />
                      <Skeleton variant="text" width="50%" height={20} />
                    </Grid>
                  ))}
                </Grid>
              </Box>

              <Box
                sx={{
                  my: 2,
                  textAlign: "left",
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                }}
              >
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <Skeleton
                    variant="rectangular"
                    width={20}
                    height={20}
                    sx={{ borderRadius: "4px" }}
                  />
                  <Skeleton variant="text" width="80%" height={24} />
                </Box>
                <Grid container rowSpacing={2} columnSpacing={2}>
                  {Array.from({ length: 4 }).map((_, index) => (
                    <Grid item xs={6} key={index}>
                      <Skeleton variant="text" width="60%" height={16} />
                      <Skeleton variant="text" width="40%" height={20} />
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Application Progress Stepper loader */}
              <Box
                sx={{
                  p: 1,
                  border: "1px solid rgba(215, 216, 222, 1)",
                  borderRadius: 2,
                  mb: 2,
                  mt: 2,
                }}
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Skeleton variant="text" width={180} height={24} />
                  <Skeleton variant="circular" width={24} height={24} />
                </Box>
                <Box display="flex" flexDirection="column" gap={2}>
                  {Array.from({ length: 6 }).map((_, stepIndex) => (
                    <Box
                      key={stepIndex}
                      display="flex"
                      alignItems="center"
                      gap={2}
                    >
                      <Skeleton
                        variant="rectangular"
                        width={32}
                        height={32}
                        sx={{ borderRadius: "6px" }}
                      />
                      <Box flex={1}>
                        <Skeleton variant="text" width="80%" height={18} />
                        <Skeleton variant="text" width="60%" height={14} />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* Continue Button */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height={40}
                sx={{ borderRadius: "8px" }}
              />
            </Box>
          </Box>
        ) : (
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "100%",
                  margin: "0",
                  maxWidth: {
                    // xs: "min(95vw, 380px)",
                    // sm: "min(95vw, 380px)",
                    // md: 900,
                    // lg: 1350,
                    // xl: 1780,
                  },
                  overflowX: "hidden",
                }}
              >
                <Carousel
                  swipeable={false}
                  draggable={false}
                  showDots={false}
                  key={window.location.pathname || "loan-products-carousel"}
                  responsive={responsive}
                  infinite={false}
                  arrows={false}
                  ssr={true} // means to render carousel on server-side.
                  autoPlay={false}
                  autoPlaySpeed={1000}
                  keyBoardControl={true}
                  customTransition="transform 300ms ease-in-out"
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  deviceType={isXsOrSm ? "mobile" : "desktop"}
                  dotListClass="custom-dot-list-style"
                  // itemClass="carousel-item-padding-40-px"
                  partialVisible={true} // Enable partial visibility of items
                  centerMode={false} // Disable center mode for better control
                  minimumTouchDrag={50} // Minimum drag distance for sliding
                  afterChange={(previousSlide: number, state: any) => {
                    const current = state?.currentSlide ?? previousSlide ?? 0;
                    setSelectedAppIndex(current);
                    const trackingId = applications?.[current]?.submissionId;
                    if (trackingId) {
                      fetchLatestNotifications(trackingId);
                    }
                  }}
                  itemClass="carousel-item-padding-updated"
                  containerClass="carousel-container-updated-new"
                // itemClass="full-width-carousel-item"
                >
                  {applications?.map((selectedApp, index) => {
                    let appDetails: any;
                    let fields: Record<string, any> = {};
                    const leadDataArr =
                      leadDetailsData[selectedApp?.submissionId];
                    const sanctionDataArr =
                      sanctionDetailsData?.[selectedApp?.submissionId];
                    const status = selectedApp?.status;

                    const normalizedProvisionalOffer =
                      breData?.[
                        selectedApp?.submissionId
                      ]?.Provisional_Offer?.toLowerCase();
                    const isSanctioned =
                      selectedApp?.status?.trim().toLowerCase() ===
                      normalize(APP_STATUS.SANCTIONED);
                    const shouldShowValue =
                      !selectedApp?.partnerStartedJourney || isSanctioned;

                    // Define partnerStartedJourneyFlag here so it's accessible in the entire component scope
                    const partnerStartedJourneyFlag =
                      selectedApp?.partnerStartedJourney;

                    const loanAmountSanctioned = sanctionDataArr?.find(
                      (item: any) => item?.name === "loanAmountSanctioned",
                    )?.value;
                    const maxTenure = sanctionDataArr?.find(
                      (item: any) => item?.name === "maxTenure",
                    )?.value;
                    const vasAmount = sanctionDataArr?.find(
                      (item: any) => item?.name === "vasAmount",
                    )?.value;
                    const currency = sanctionDataArr?.find(
                      (item: any) => item?.name === "currency",
                    )?.value;

                    const finalLoanAmountValue =
                      partnerStartedJourneyFlag && isSanctioned
                        ? loanAmountSanctioned || "-"
                        : (shouldShowValue &&
                          breData?.[selectedApp.submissionId]
                            ?.Max_Loan_Amount) ||
                        "-";

                    const formatCurrency = (value: any) => {
                      const num = parseFloat(value);
                      if (isNaN(num)) return "-";
                      return `₹ ${new Intl.NumberFormat('en-IN').format(num)}`;
                    };

                    const finalCurrencyValue =
                      partnerStartedJourneyFlag && isSanctioned
                        ? currency || "-"
                        : (shouldShowValue &&
                          breData?.[selectedApp.submissionId]?.currency) ||
                        "-";

                    const finalVasAmountValue =
                      partnerStartedJourneyFlag && isSanctioned
                        ? vasAmount || "-"
                        : "-";

                    const getRepaymentLabel = (type: string) => {
                      let val = typeof type === "string" ? type?.toUpperCase() : type;
                      switch (val) {
                        case "PINT":
                          return "Partial interest";
                        case "SINT":
                          return "Simple interest";
                        case "EMI":
                          return "EMI";
                        default:
                          return type || "-";
                      }
                    };

                    // Fixed helper to return specific content or null
                    const getTooltipContent = (type: string) => {
                      let val = typeof type === "string" ? type?.toUpperCase() : type;
                      switch (val) {
                        case "PINT":
                          return (
                            <Typography variant="caption">
                              <b>Partial Interest:</b> Pay a portion of the interest now; the rest is added to your principal for the next stage of your loan.
                            </Typography>
                          );
                        case "SINT":
                          return (
                            <Typography variant="caption">
                              <b>Simple Interest:</b> Pay full interest now; your principal repayment begins after the moratorium.
                            </Typography>
                          );
                        default:
                          return null;
                      }
                    };

                    const activeTooltip = getTooltipContent(breData?.[selectedApp.submissionId]?.Repayment_Type);

                    const finalMaxTenureValue =
                      partnerStartedJourneyFlag && isSanctioned
                        ? maxTenure || "-"
                        : shouldShowValue &&
                          breData?.[selectedApp.submissionId]?.Max_Tenure
                          ? `${breData?.[selectedApp.submissionId]?.Max_Tenure
                          } Months`
                          : "-";

                    const message = getApplicationMessage(
                      status,
                      normalizedProvisionalOffer,
                      partnerStartedJourneyFlag
                    );

                    if (
                      selectedApp?.partnerStartedJourney &&
                      Array.isArray(leadDataArr) &&
                      leadDataArr.length > 0
                    ) {
                      // Map array of {label, name, value} to {name: value}
                      appDetails = leadDataArr.reduce((acc: any, item: any) => {
                        acc[item?.name] = item?.value || "-";
                        return acc;
                      }, {});
                    } else {
                      fields = [
                        ...(selectedApp?.horizontalSteps?.[0]
                          ?.verticalSteps?.[0]?.fields || []),
                        ...(selectedApp.horizontalSteps?.[0]?.verticalSteps?.[1]
                          ?.fields || []),
                        ...(selectedApp.horizontalSteps?.[0]?.verticalSteps?.[2]
                          ?.fields || []),
                      ].reduce<Record<string, any>>(
                        (acc, field) => ({ ...acc, ...field }),
                        {}
                      );
                      appDetails = {
                        country: fields.country || "-",
                        university: fields.university || "-",
                        institute: fields.institute || "-",
                        courseType: fields.courseType || "-",
                        appliedLoanAmount:
                          parseFloat(fields.loanAmount) &&
                            !isNaN(parseFloat(fields.loanAmount))
                            ? parseFloat(fields.loanAmount).toLocaleString()
                            : "-",
                        createdOn: formatDateToShortMonth(
                          selectedApp?.createdAt
                        ),
                        partnerName: applications?.[selectedAppIndex]?.partnerName || "-",
                        salesManager: applications?.[selectedAppIndex]?.assignedSMName || "-",
                        // lastActionDate: formatDateToShortMonth(
                        //    selectedApp?.updatedAt
                        // ),
                        // completionRate: "-",
                        // courseName: fields.courseName || "-",
                      };
                    }

                    // 💡 Refactored logic to use utility functions
                    const finalSteps = getCombinedApplicationSteps(selectedApp, selectedApp?.status);
                    const activeStep = findActiveStep(finalSteps);

                    const skipFields = [
                      "status",
                      "applicationid",
                      "salesmanageremail",
                      "salesmanagermobile",
                      "coursename",
                      "coursecategory",
                      "admissionstatus",
                      "totalcost",
                      "product",
                    ].map((i) => i.toLowerCase());
                    const hiddenOnMobileFields = ["institute", "coursetype"].map((i) => i.toLowerCase());

                    const canToggleProvisional =
                      normalizedProvisionalOffer === "yes" ||
                      normalizedProvisionalOffer === undefined ||
                      (partnerStartedJourneyFlag &&
                        normalizedProvisionalOffer === "no" &&
                        selectedApp?.status !== APP_STATUS.DISBURSED &&
                        selectedApp?.status !== APP_STATUS.ELIGIBILITY_FAILED &&
                        selectedApp?.status !== APP_STATUS.APPLICATION_REJECTED &&
                        selectedApp?.status !== APP_STATUS.APPLICATION_CLOSED &&
                        selectedApp?.status !== APP_STATUS.DECLINED_BY_CREDIT);

                    return (
                      <div key={selectedApp.submissionId}>
                        <Box className="card-contaner-existing-app">
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between" // Distribute space
                            flexWrap="wrap"
                            gap={1} // Gap between title/chip and buttons
                            mb={2}
                            sx={{
                              boxSizing: "border-box",
                              width: "100%", // or 100% if parent limits width
                            }}
                          >
                            {/* 🎯 Left: Title and Status */}
                            {selectedApp?.isEligibilityChecked !== false && (
                              <Box
                                display="flex"
                                gap={1} // Reduced gap to max 4px for tight mobile screens
                                flexWrap="nowrap"
                                justifyContent="space-between"
                                alignItems="center"
                                flexShrink={0}
                                width="100%"
                              >
                                <UploadButton
                                  onClick={handleUploadDocument}
                                  sx={{
                                    flex: 1, // Auto flex basis
                                    minWidth: "auto !important", // Overrides default MUI Button minWidth
                                    height: "32px",
                                    minHeight: "unset",
                                    borderRadius: "6px",
                                    color: "#00b3b5",
                                    borderColor: "#00b3b5",
                                    fontSize: { xs: "0.68rem", sm: "0.8rem" }, // Scaled down for mobile text fit
                                    padding: "2px 4px !important", // Compact padding prevents text overflow
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                  }}
                                >
                                  <img
                                    src={UploadIcon}
                                    alt="Upload"
                                    style={{ marginRight: "3px", height: 13, flexShrink: 0 }}
                                  />
                                  Upload Document
                                </UploadButton>

                                <UploadButton
                                  onClick={handleViewSummary}
                                  sx={{
                                    flex: 1,
                                    minWidth: "auto !important",
                                    height: "32px",
                                    minHeight: "unset",
                                    borderRadius: "6px",
                                    color: "#00b3b5",
                                    borderColor: "#00b3b5",
                                    fontSize: { xs: "0.68rem", sm: "0.8rem" },
                                    padding: "2px 4px !important",
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                  }}
                                >
                                  <img
                                    src={ViewIcon}
                                    alt="View Summary"
                                    style={{ marginRight: "3px", height: 13, flexShrink: 0 }}
                                  />
                                  View Summary
                                </UploadButton>
                              </Box>
                            )}

                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 1,
                                width: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <Box sx={{ minWidth: 0, flex: 1 }}>
                                <TruncatedTextWithTooltip
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#333",
                                    display: "block",
                                    width: "100%",
                                    pointerEvents: "auto"
                                  }}
                                  text={selectedApp?.partnerStartedJourney
                                    ? appDetails.courseName || "-"
                                    : fields.courseName || "-"
                                  }
                                  limit={15}
                                />
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: "#333",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  [#{selectedApp?.submissionId}]
                                </Typography>
                              </Box>
                               {/* {selectedApp?.externalId && <CrmIdChip crmId={selectedApp?.externalId} label="App Id:" />} */}
                              <Chip
                                label={selectedApp?.status}
                                className="card-contaner-status"
                                sx={{
                                  flexShrink: 0,
                                  height: 'auto',
                                  '& .MuiChip-label': { px: 1 }
                                }}
                              />
                            </Box>
                           
                          </Box>

                          <Grid
                            container
                            spacing={3}
                            className="card-contaner-section"
                          >
                            {/* Increased spacing between details and offer box */}
                            <Grid item xs={12} md={8}>
                              <Grid container rowSpacing={2} columnSpacing={4}>
                                {/* --- Sales Manager Tooltip logic --- */}
                                {(() => {
                                  // Only for leadDetailsData-driven cards (partnerStartedJourney)
                                  const isLeadDetails =
                                    selectedApp?.partnerStartedJourney &&
                                    Array.isArray(leadDataArr) &&
                                    leadDataArr.length > 0;
                                  if (!isLeadDetails) {
                                    // fallback: keep old rendering
                                    const SalespersonTooltipContent = (
                                      <>
                                        {
                                          <Typography
                                            variant="caption"
                                            display="block"
                                          >
                                            Email:{" "}
                                            {selectedApp?.assignedSMEmail ||
                                              "-"}
                                          </Typography>
                                        }
                                        {
                                          <Typography
                                            variant="caption"
                                            display="block"
                                          >
                                            Mobile:{" "}
                                            {selectedApp?.assignedSMMobileNumber ||
                                              "-"}
                                          </Typography>
                                        }
                                      </>
                                    );
                                    return (
                                      <>
                                        {Object.entries(appDetails || {})
                                          .filter(
                                            ([field]) =>
                                              !skipFields.includes(
                                                field.toLowerCase(),
                                              ) &&
                                              (isXsOrSm &&
                                                !hiddenOnMobileFields.includes(
                                                  field.toLowerCase(),
                                                )),
                                          )
                                          .map(([field, value]: any) => {
                                            // Format the label once
                                            const formattedLabel = field
                                              ?.replace(/[_-]+/g, " ")
                                              .replace(/([A-Z])/g, " $1")
                                              .replace(/\s+/g, " ")
                                              .replace(/^./, (str: any) =>
                                                str.toUpperCase(),
                                              )
                                              .split(" ")
                                              .map(
                                                (word: any) =>
                                                  word.charAt(0).toUpperCase() +
                                                  word.slice(1),
                                              )
                                              .join(" ")
                                              .trim();

                                            // Check if label contains SM name
                                            const shouldShowTooltip =
                                              formattedLabel.includes(
                                                "Sales Manager",
                                              );

                                            return (
                                              <Grid
                                                item
                                                xs={6}
                                                sm={3}
                                                key={field}
                                                sx={{ textAlign: "left" }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    mb: 0.5,
                                                  }}
                                                >
                                                  <Typography
                                                    className="card-contaner-lable"
                                                    sx={{
                                                      marginRight: "4px !important",
                                                      marginBottom: "0 !important",
                                                    }}
                                                  >
                                                    {formattedLabel}
                                                  </Typography>

                                                  {/* mobile view */}
                                                  {shouldShowTooltip && (
                                                    <Tooltip
                                                      title={SalespersonTooltipContent}
                                                      placement="top-start"
                                                      arrow
                                                      enterTouchDelay={0}
                                                      leaveTouchDelay={3000}
                                                    >
                                                      <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
                                                        <IconButton
                                                          size="small"
                                                          disableRipple
                                                          sx={{
                                                            p: 0,
                                                            width: '0px !important',
                                                            minWidth: '0px !important',
                                                            height: '0px !important',
                                                            background: "transparent !important",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            "&:hover, &:active": {
                                                              background: "rgba(0, 0, 0, 0.04) !important",
                                                              width: '0px !important',
                                                              minWidth: '0px !important',
                                                              height: '0px !important',
                                                              p: '0px !important',
                                                            },
                                                          }}
                                                        >
                                                          <InfoOutlinedIcon
                                                            sx={{
                                                              fontSize: "14px",
                                                              color: "#a5a3ae",
                                                            }}
                                                          />
                                                        </IconButton>
                                                      </Box>
                                                    </Tooltip>
                                                  )}
                                                </Box>
                                                <Typography
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                  }}
                                                >
                                                  <Typography
                                                    style={{
                                                      fontSize: "13px",
                                                      color: "#6F6B7D",
                                                    }}
                                                  >
                                                    {field ===
                                                      "appliedLoanAmount"
                                                      ? "₹ "
                                                      : ""}
                                                  </Typography>

                                                  <TruncatedTextWithTooltip
                                                    className="card-contaner-value"
                                                    text={value}
                                                  // limit={isIphoneSE ? 25 : 35}
                                                  />
                                                </Typography>
                                              </Grid>
                                            );
                                          })}
                                      </>
                                    );
                                  }

                                  // For leadDetailsData-driven cards, use array for label/value rendering
                                  // Find sales manager details
                                  const salesManagerNameObj = leadDataArr.find(
                                    (item: any) =>
                                      item.name === "salesManagerName"
                                  );
                                  const salesManagerEmailObj = leadDataArr.find(
                                    (item: any) =>
                                      item.name === "salesManagerEmail"
                                  );
                                  const salesManagerMobileObj =
                                    leadDataArr.find(
                                      (item: any) =>
                                        item.name === "salesManagerMobile"
                                    );
                                  const salesPersonDetails = {
                                    name: salesManagerNameObj?.value || "",
                                    email: salesManagerEmailObj?.value || "",
                                    mobile: salesManagerMobileObj?.value || "",
                                  };
                                  const SalespersonTooltipContent = (
                                    <>
                                      {salesPersonDetails && (
                                        <Typography
                                          variant="caption"
                                          display="block"
                                        >
                                          Email:{" "}
                                          {salesPersonDetails?.email || "-"}
                                        </Typography>
                                      )}
                                      {salesPersonDetails && (
                                        <Typography
                                          variant="caption"
                                          display="block"
                                        >
                                          Mobile:{" "}
                                          {salesPersonDetails?.mobile || "-"}
                                        </Typography>
                                      )}
                                    </>
                                  );
                                  // Filter out unwanted fields and ensure 'salesManagerName' is last
                                  let filteredArr = leadDataArr.filter(
                                    (item: any) =>
                                      !skipFields.includes(
                                        item.name.toLowerCase()
                                      ) &&
                                      (isXsOrSm &&
                                        !hiddenOnMobileFields.includes(
                                        item?.name.toLowerCase(),
                                      )),
                                  );
                                  // Add partnerName
                                  filteredArr.push({
                                    name: "partnerName",
                                    label: "Partner Name",
                                    value: selectedApp.partnerName,
                                  });
                                  const salesManagerIdx = filteredArr.findIndex(
                                    (item: any) =>
                                      item.name === "salesManagerName"
                                  );
                                  if (salesManagerIdx !== -1) {
                                    const [salesManagerItem] =
                                      filteredArr.splice(salesManagerIdx, 1);
                                    filteredArr.push(salesManagerItem);
                                  }
                                  return (
                                    <>
                                      {filteredArr.map(
                                        (item: any, idx: number) => {
                                          // Format createdOn date if present
                                          const formattedItem =
                                            item.name === "createdOn" &&
                                              item.value
                                              ? {
                                                ...item,
                                                value: formatDateToShortMonth(
                                                  item.value
                                                ),
                                              }
                                              : item;
                                          return (
                                            <Grid
                                              item
                                              xs={6}
                                              sm={3}
                                              key={item.name}
                                              sx={{ textAlign: "left" }}
                                            >
                                              {/* when partnerstartedjourney true */}
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 0.5,
                                                }}
                                              >
                                                <Typography className="card-contaner-lable">
                                                  {item.label
                                                    ?.replace(/[_-]+/g, " ")
                                                    .replace(/([A-Z])/g, " $1")
                                                    .replace(/\s+/g, " ")
                                                    .replace(/^./, (str: any) => str.toUpperCase())
                                                    .split(" ")
                                                    .map(
                                                      (word: any) =>
                                                        word.charAt(0).toUpperCase() + word.slice(1)
                                                    )
                                                    .join(" ")
                                                    .replace("Sales Manager Name", "Sales Manager")
                                                    .trim()
                                                  }
                                                </Typography>
                                                {item.label ===
                                                  "Sales Manager Name" &&
                                                  (salesPersonDetails.email ||
                                                    salesPersonDetails.mobile) && (
                                                    <Tooltip
                                                      title={SalespersonTooltipContent}
                                                      placement="top-start"
                                                      arrow
                                                      enterTouchDelay={0}
                                                      leaveTouchDelay={3000}
                                                    >
                                                      <Box sx={{ display: "flex", alignItems: "center", ml: 1, mb: 1 }}>
                                                        <IconButton
                                                          size="small"
                                                          sx={{
                                                            p: 0,
                                                            width: '0px !important',
                                                            minWidth: '0px !important',
                                                            height: '0px !important',
                                                            background: "transparent !important",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            "&:hover, &:active": {
                                                              background: "rgba(0, 0, 0, 0.04) !important",
                                                              width: '0px !important',
                                                              minWidth: '0px !important',
                                                              height: '0px !important',
                                                              p: '0px !important',
                                                            },
                                                          }}
                                                          aria-label="Salesperson contact details"
                                                        >
                                                          <InfoOutlinedIcon
                                                            sx={{
                                                              fontSize: "14px",
                                                              color: "#a5a3ae",
                                                              cursor: "pointer",
                                                            }}
                                                          />
                                                        </IconButton>
                                                      </Box>
                                                    </Tooltip>
                                                  )}
                                              </Box>
                                              <TruncatedTextWithTooltip
                                                className="card-contaner-value"
                                                text={formattedItem.value}
                                              // limit={15}
                                              />
                                            </Grid>
                                          );
                                        },
                                      )}
                                    </>
                                  );
                                })()}
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <div
                                className={`${!partnerStartedJourneyFlag &&
                                  normalizedProvisionalOffer === "yes"
                                  ? "right-side-box-provision"
                                  : partnerStartedJourneyFlag &&
                                    (selectedApp?.status ===
                                      APP_STATUS.DISBURSED ||
                                      selectedApp?.status ===
                                      APP_STATUS.SANCTIONED)
                                    ? "right-side-box-provision"
                                    : "right-side-box"
                                  } `}
                                style={isXsOrSm ? {} : { minHeight: "170px" }}
                              >
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  onClick={
                                    canToggleProvisional
                                      ? () =>
                                        setIsProvisionalOfferExpanded(
                                          !isProvisionalOfferExpanded,
                                        )
                                      : undefined
                                  }
                                  sx={{
                                    cursor: canToggleProvisional
                                      ? "pointer"
                                      : "default",
                                  }}
                                >
                                  <Grid
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {selectedApp?.status ===
                                      APP_STATUS.SANCTIONED ? (
                                      <img
                                        src={
                                          !partnerStartedJourneyFlag &&
                                            normalizedProvisionalOffer === "yes"
                                            ? textFile
                                            : LockSquare
                                        }
                                        alt="lock-square"
                                      />
                                    ) : !partnerStartedJourneyFlag &&
                                      normalizedProvisionalOffer ===
                                      "no" ? null : (
                                      selectedApp?.isEligibilityChecked !== false &&
                                      selectedApp?.status !==
                                      APP_STATUS.DISBURSED &&
                                      selectedApp?.status !==
                                      APP_STATUS.ELIGIBILITY_FAILED &&
                                      selectedApp?.status !==
                                      APP_STATUS.APPLICATION_REJECTED &&
                                      selectedApp?.status !==
                                      APP_STATUS.APPLICATION_CLOSED &&
                                      selectedApp?.status !==
                                      APP_STATUS.DECLINED_BY_CREDIT && (
                                        <img
                                          src={
                                            !partnerStartedJourneyFlag &&
                                              normalizedProvisionalOffer === "yes"
                                              ? textFile
                                              : LockSquare
                                          }
                                          alt="lock-square"
                                        />
                                      )
                                    )}
                                    {/* Icon */}
                                    <Typography
                                      // className="right-side-heading"
                                      sx={{
                                        ml: 1.5,
                                        mr: 1,
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        color: "#333",
                                      }}
                                    >
                                      {selectedApp?.isEligibilityChecked !== null && !selectedApp?.isEligibilityChecked ? STATUS_MESSAGES?.ELIGIBILITY_CHECK_FAILED : message}
                                    </Typography>
                                  </Grid>
                                  {selectedApp?.status ===
                                    APP_STATUS.SANCTIONED ? (
                                    <Box sx={{ cursor: "pointer", pt: 1 }}>
                                      {isProvisionalOfferExpanded ? (
                                        <KeyboardArrowUpIcon
                                          sx={{
                                            color: "rgba(0, 179, 181, 1)",
                                          }}
                                        />
                                      ) : (
                                        <KeyboardArrowDownIcon
                                          sx={{
                                            color: "rgba(0, 179, 181, 1)",
                                          }}
                                        />
                                      )}
                                    </Box>
                                  ) : !partnerStartedJourneyFlag &&
                                    normalizedProvisionalOffer ===
                                    "no" ? null : (
                                    selectedApp?.isEligibilityChecked !== false &&
                                    selectedApp?.status !==
                                    APP_STATUS.DISBURSED &&
                                    selectedApp?.status !==
                                    APP_STATUS.ELIGIBILITY_FAILED &&
                                    selectedApp?.status !==
                                    APP_STATUS.APPLICATION_REJECTED &&
                                    selectedApp?.status !==
                                    APP_STATUS.APPLICATION_CLOSED &&
                                    selectedApp?.status !==
                                    APP_STATUS.DECLINED_BY_CREDIT && (
                                      <Box sx={{ cursor: "pointer", pt: 1 }}>
                                        {isProvisionalOfferExpanded ? (
                                          <KeyboardArrowUpIcon
                                            sx={{
                                              color: "rgba(0, 179, 181, 1)",
                                            }}
                                          />
                                        ) : (
                                          <KeyboardArrowDownIcon
                                            sx={{
                                              color: "rgba(0, 179, 181, 1)",
                                            }}
                                          />
                                        )}
                                      </Box>
                                    )
                                  )}
                                </Box>
                                {isProvisionalOfferExpanded &&
                                  selectedApp?.status ===
                                  APP_STATUS.SANCTIONED ? (
                                  <Grid container spacing={2} mt={1}>
                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        {partnerStartedJourneyFlag
                                          ? "Loan Amount"
                                          : "Offer loan amount"}
                                      </Typography>
                                      <Typography className="right-side-value">
                                        {formatCurrency(finalLoanAmountValue)}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        Tenure
                                      </Typography>
                                      <Typography className="right-side-value">
                                        {finalMaxTenureValue}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        {partnerStartedJourneyFlag &&
                                          isSanctioned
                                          ? "VAS Amount"
                                          : "Repayment type"}
                                      </Typography>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                          {partnerStartedJourneyFlag && isSanctioned
                                            ? formatCurrency(finalVasAmountValue)
                                            : (shouldShowValue && getRepaymentLabel(breData?.[selectedApp.submissionId]?.Repayment_Type)) || "-"
                                          }
                                        </Typography>

                                        {!partnerStartedJourneyFlag && breData?.[selectedApp.submissionId]?.Repayment_Type && (
                                          <Tooltip
                                            title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>}
                                            arrow
                                            placement="top"
                                            enterTouchDelay={0}
                                            leaveTouchDelay={3000}
                                          >
                                            <InfoOutlined
                                              sx={{
                                                fontSize: "16px",
                                                cursor: "pointer",
                                                color: "action.active",
                                                userSelect: "auto",
                                                WebkitUserSelect: "auto"
                                              }}
                                            />
                                          </Tooltip>
                                        )}
                                      </Box>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        Currency
                                      </Typography>
                                      <Typography className="right-side-value">
                                        {finalCurrencyValue}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : !partnerStartedJourneyFlag &&
                                  normalizedProvisionalOffer ===
                                  "no" ? null : isProvisionalOfferExpanded &&
                                    selectedApp?.isEligibilityChecked !== false &&
                                    selectedApp?.status !==
                                    APP_STATUS.DISBURSED &&
                                    selectedApp?.status !==
                                    APP_STATUS.ELIGIBILITY_FAILED &&
                                    selectedApp?.status !==
                                    APP_STATUS.APPLICATION_REJECTED &&
                                    selectedApp?.status !==
                                    APP_STATUS.APPLICATION_CLOSED &&
                                    selectedApp?.status !==
                                    APP_STATUS.DECLINED_BY_CREDIT ? (
                                  <Grid container spacing={2} mt={1}>
                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        {partnerStartedJourneyFlag
                                          ? "Loan Amount"
                                          : "Offer loan amount"}
                                      </Typography>
                                      <Typography className="right-side-value">
                                        {formatCurrency(finalLoanAmountValue)}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        Tenure
                                      </Typography>
                                      <Typography className="right-side-value">
                                        {finalMaxTenureValue}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        {partnerStartedJourneyFlag &&
                                          isSanctioned
                                          ? "VAS Amount"
                                          : "Repayment type"}
                                      </Typography>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                          {partnerStartedJourneyFlag && isSanctioned
                                            ? formatCurrency(finalVasAmountValue)
                                            : (shouldShowValue && getRepaymentLabel(breData?.[selectedApp.submissionId]?.Repayment_Type)) || "-"
                                          }
                                        </Typography>

                                        {!partnerStartedJourneyFlag && breData?.[selectedApp.submissionId]?.Repayment_Type && (
                                          <Tooltip
                                            title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>}
                                            arrow
                                            placement="top"
                                            enterTouchDelay={0}
                                            leaveTouchDelay={3000}
                                          >
                                            <InfoOutlined
                                              sx={{
                                                fontSize: "16px",
                                                cursor: "pointer",
                                                color: "action.active",
                                                userSelect: "auto",
                                                WebkitUserSelect: "auto"
                                              }}
                                            />
                                          </Tooltip>
                                        )}
                                      </Box>
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography className="right-side-lable">
                                        Currency
                                      </Typography>
                                      <Typography className="right-side-value">
                                        {finalCurrencyValue}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                ) : null}
                              </div>
                            </Grid>
                          </Grid>
                          <SalesManagerContact
                            name={selectedApp?.assignedSMName}
                            mobile={selectedApp?.assignedSMMobileNumber}
                            email={selectedApp?.assignedSMEmail}
                            partnerName={selectedApp?.partnerName}
                            trackingId={selectedApp?.submissionId}
                            onCallbackResult={({ message, severity }) =>
                              setCallbackSnackbar({ open: true, message, severity })
                            }
                          />
                          <Box sx={{ mt: 2, mb: 2 }}>
                            <NextStepBanner
                              status={selectedApp?.status}
                              managerName={selectedApp?.assignedSMName}
                              onResume={() => handleResumeApplication(selectedApp)}
                              isResumeLoading={isResumeLoading}
                              completedSteps={finalSteps.filter(
                                (step: any) => step?.status === "completed" || step?.isCompleted
                              ).length}
                              totalSteps={finalSteps.length}
                            />
                          </Box>   
                          {/* === Application Progress Stepper (Mobile Accordion) === */}
                          <ApplicationProgressStepper
                            data={finalSteps}
                            activeStep={activeStep}
                            isLoading={isSliderLoading}
                            partnerStartedJourney={
                              selectedApp?.partnerStartedJourney
                            }
                          />
                        </Box>
                      </div>
                    );
                  })}
                </Carousel>
              </Box>
            </Grid>
          </Grid>
        )
      ) : (
        <></>
      )}

      {!isXsOrSm ? (
        isSliderLoading ? (
          <Box
            sx={{
              width: "100%",
              margin: "0 auto",
              maxWidth: "100%",
              textAlign: "center",
            }}
          >
            <div className="card-contaner">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                gap={2}
                mb={1}
                sx={{
                  px: 1,
                  boxSizing: "border-box",
                  width: "100%",
                }}
              >
                {/* Left Title and Status */}
                <Box display="flex" alignItems="center" gap={1} flexShrink={1}>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "2rem" }}
                    width={300}
                  />
                </Box>

                {/* Right Action Buttons */}
                <Box
                  display="flex"
                  gap={1.5}
                  flexWrap="wrap"
                  justifyContent="flex-end"
                  alignItems="center"
                  flexShrink={0}
                >
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={80}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                </Box>
              </Box>

              {/* Application Details */}
              <Skeleton height={2} width="100%" sx={{ my: 2 }} />
              <Grid container spacing={3} sx={{ my: 2 }}>
                <Grid item xs={12} md={8}>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1.2rem", mb: 2 }}
                    width={200}
                  />
                  <Grid container rowSpacing={2} columnSpacing={4}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <Grid
                        item
                        xs={6}
                        sm={3}
                        key={index}
                        sx={{ textAlign: "left" }}
                      >
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "1rem" }}
                          width="80%"
                        />
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "1rem" }}
                          width="60%"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className="right-side-box">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Skeleton
                        variant="rectangular"
                        width={24}
                        height={24}
                        sx={{ mr: 1, borderRadius: "5px" }}
                      />
                      <Skeleton
                        variant="text"
                        sx={{ fontSize: "1.1rem" }}
                        width="80%"
                      />
                    </Box>
                    <Grid container spacing={2} sx={{ textAlign: "left" }}>
                      {Array.from({ length: 4 }).map((_, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <Skeleton
                            variant="text"
                            sx={{ fontSize: "0.9rem" }}
                            width="70%"
                          />
                          <Skeleton
                            variant="text"
                            sx={{ fontSize: "1rem" }}
                            width="50%"
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </Grid>
              </Grid>

              {/* Application Progress loader */}
              <Skeleton height={2} width="100%" sx={{ my: 2 }} />
              <Skeleton
                variant="text"
                sx={{ fontSize: "1.2rem", mb: 2 }}
                width={200}
              />
              <Stepper
                activeStep={0}
                connector={
                  <Skeleton
                    variant="text"
                    width={50}
                    height={5}
                    sx={{ mx: 1 }}
                  />
                }
                sx={{ mb: 2 }}
              >
                {Array.from({ length: 6 }).map((_, index) => (
                  <Step key={index}>
                    <Box display="flex" flexDirection={"column"}>
                      <Skeleton
                        variant="rectangular"
                        width={25}
                        height={25}
                        sx={{ borderRadius: "5px" }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          mt: 2,
                        }}
                      >
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "0.7rem" }}
                          width={90}
                        />
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "0.6rem" }}
                          width={70}
                        />
                      </Box>
                    </Box>
                  </Step>
                ))}
              </Stepper>
            </div>
          </Box>
        ) : !isSliderLoading && applications?.length > 0 ? (
          <Box
            sx={{
              width: "100%",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            <Slider {...sliderSettings}>
              {applications?.map((selectedApp, index) => {
                let appDetails: any;
                let fields: Record<string, any> = {};
                const leadDataArr = leadDetailsData[selectedApp?.submissionId];
                const sanctionDataArr =
                  sanctionDetailsData?.[selectedApp?.submissionId];
                const status = selectedApp?.status;
                const normalizedProvisionalOffer =
                  breData?.[
                    selectedApp?.submissionId
                  ]?.Provisional_Offer?.toLowerCase();
                const isSanctioned =
                  selectedApp?.status?.trim().toLowerCase() ===
                  normalize(APP_STATUS.SANCTIONED);
                const shouldShowValue =
                  !selectedApp?.partnerStartedJourney || isSanctioned;
                // Define partnerStartedJourneyFlag here so it's accessible in the entire component scope
                const partnerStartedJourneyFlag =
                  selectedApp?.partnerStartedJourney;

                const message = getApplicationMessage(
                  status,
                  normalizedProvisionalOffer,
                  partnerStartedJourneyFlag
                );


                const loanAmountSanctioned = sanctionDataArr?.find(
                  (item: any) => item?.name === "loanAmountSanctioned",
                )?.value;
                const maxTenure = sanctionDataArr?.find(
                  (item: any) => item?.name === "maxTenure",
                )?.value;
                const vasAmount = sanctionDataArr?.find(
                  (item: any) => item?.name === "vasAmount",
                )?.value;
                const currency = sanctionDataArr?.find(
                  (item: any) => item?.name === "currency",
                )?.value;

                const finalLoanAmountValue =
                  partnerStartedJourneyFlag && isSanctioned
                    ? loanAmountSanctioned || "-"
                    : (shouldShowValue &&
                      breData?.[selectedApp.submissionId]?.Max_Loan_Amount) ||
                    "-";

                const formatCurrency = (value: any) => {
                  const num = parseFloat(value);
                  if (isNaN(num)) return "-";
                  return `₹ ${new Intl.NumberFormat('en-IN').format(num)}`;
                };

                const finalCurrencyValue =
                  partnerStartedJourneyFlag && isSanctioned
                    ? currency || "-"
                    : (shouldShowValue &&
                      breData?.[selectedApp.submissionId]?.currency) ||
                    "-";

                const finalVasAmountValue =
                  partnerStartedJourneyFlag && isSanctioned
                    ? vasAmount || "-"
                    : "-";

                const getRepaymentLabel = (type: string) => {
                  let val = typeof type === "string" ? type?.toUpperCase() : type;
                  switch (val) {
                    case "PINT":
                      return "Partial interest";
                    case "SINT":
                      return "Simple interest";
                    case "EMI":
                      return "EMI";
                    default:
                      return type || "-";
                  }
                };

                // Fixed helper to return specific content or null
                const getTooltipContent = (type: string) => {
                  let val = typeof type === "string" ? type?.toUpperCase() : type;
                  switch (val) {
                    case "PINT":
                      return (
                        <Typography variant="caption">
                          <b>Partial Interest:</b> Pay a portion of the interest now; the rest is added to your principal for the next stage of your loan.
                        </Typography>
                      );
                    case "SINT":
                      return (
                        <Typography variant="caption">
                          <b>Simple Interest:</b> Pay full interest now; your principal repayment begins after the moratorium.
                        </Typography>
                      );
                    default:
                      return null;
                  }
                };

                const activeTooltip = getTooltipContent(breData?.[selectedApp.submissionId]?.Repayment_Type);

                const finalMaxTenureValue =
                  partnerStartedJourneyFlag && isSanctioned
                    ? maxTenure || "-"
                    : shouldShowValue &&
                      breData?.[selectedApp.submissionId]?.Max_Tenure
                      ? `${breData?.[selectedApp.submissionId]?.Max_Tenure
                      } Months`
                      : "-";

                if (
                  selectedApp?.partnerStartedJourney &&
                  Array.isArray(leadDataArr) &&
                  leadDataArr.length > 0
                ) {
                  // Map array of {label, name, value} to {name: value}
                  appDetails = leadDataArr.reduce((acc: any, item: any) => {
                    acc[item?.name] = item?.value || "-";
                    return acc;
                  }, {});
                } else {
                  fields = [
                    ...(selectedApp?.horizontalSteps?.[0]?.verticalSteps?.[0]
                      ?.fields || []),
                    ...(selectedApp.horizontalSteps?.[0]?.verticalSteps?.[1]
                      ?.fields || []),
                    ...(selectedApp.horizontalSteps?.[0]?.verticalSteps?.[2]
                      ?.fields || []),
                  ].reduce<Record<string, any>>(
                    (acc, field) => ({ ...acc, ...field }),
                    {}
                  );
                  appDetails = {
                    country: fields.country || "-",
                    university: fields.university || "-",
                    institute: fields.institute || "-",
                    courseType: fields.courseType || "-",
                    appliedLoanAmount:
                      parseFloat(fields.loanAmount) &&
                        !isNaN(parseFloat(fields.loanAmount))
                        ? parseFloat(fields.loanAmount).toLocaleString()
                        : "-",
                    createdOn: formatDateToShortMonth(selectedApp?.createdAt),
                    partnerName: applications?.[selectedAppIndex]?.partnerName || "-",
                    salesManager: applications?.[selectedAppIndex]?.assignedSMName || "-",
                    // lastActionDate: formatDateToShortMonth(
                    //    selectedApp?.updatedAt
                    // ),
                    // completionRate: "-",
                    // courseName: fields.courseName || "-",
                  };
                }

                // 💡 Refactored logic to use utility functions
                let finalSteps = getCombinedApplicationSteps(selectedApp, selectedApp?.status);
                let activeStep = findActiveStep(finalSteps);
                
                const allFields = selectedApp?.horizontalSteps[0].verticalSteps[1]?.fields;
                const data = allFields?.find((f: any) => f.admissionStatus?.toLowerCase() === "undecided");
                const country = allFields?.find((f: any) => f.country)?.country;
                const universityCountryId = allFields?.find((f: any) => f.universityCountryId)?.universityCountryId;

                  if (data) {
                    const isValid = checkUndecided(country, universityCountryId, selectedApp?.source, selectedApp?.isQualified, selectedApp?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.length);
                    if(isValid) {
                     finalSteps[0].isCompleted = false;
                     finalSteps[0].status = "pending";
                     finalSteps[0].isQualified = false;
                     finalSteps[0].isEligible = null;
                    }
                  }


                const skipFields = [
                  "status",
                  "applicationid",
                  "salesmanageremail",
                  "salesmanagermobile",
                  "coursename",
                  "coursecategory",
                  "admissionstatus",
                  "totalcost",
                  "product",
                ].map((i) => i.toLowerCase());


                return (
                  <div key={selectedApp.submissionId} className="slick-slide-wrapper">
                    <div className="card-contaner">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        gap={2}
                        mb={1}
                        sx={{
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        {/* 🎯 Left: Title and Status */}
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          flexShrink={1}
                        >
                          <TruncatedTextWithTooltip
                            className="card-contaner-hedging"
                            text={
                              selectedApp?.partnerStartedJourney
                                ? appDetails.courseName || "-"
                                : fields.courseName || "-"
                            }
                            limit={15}
                          />
                          <Typography className="card-contaner-hedging">
                            [#{selectedApp?.submissionId}]
                          </Typography>
                            {selectedApp?.externalId && <CrmIdChip crmId={selectedApp?.externalId} label="App Id:" />}
                          <Chip
                            label={selectedApp?.status}
                            className="card-contaner-status"
                          />
                        
                        </Box>

                        {/* 🟦 Right: Action Buttons */}

                        {![
                          APP_STATUS.DECLINED_BY_CREDIT,
                          APP_STATUS.APPLICATION_REJECTED,
                          APP_STATUS.APPLICATION_CLOSED,
                        ].includes(selectedApp?.status) &&
                          selectedApp?.isEligibilityChecked !== false && (
                            <>
                              <Box
                                display="flex"
                                gap={1.5} // Smaller gap between buttons
                                flexWrap="wrap"
                                justifyContent="flex-end" // Align buttons to the right
                                alignItems="center"
                                flexShrink={0}
                              >
                                <UploadButton
                                  onClick={() => {
                                    handleUploadDocument();
                                  }}
                                  sx={{
                                    textTransform: "none",
                                    borderColor: "#00b3b5",
                                    color: "#00b3b5",
                                    "&:hover": {
                                      borderColor: "#00999a",
                                      bgcolor: "#e0f7fa",
                                    },
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: "8px",
                                    fontSize: "0.8rem",
                                    minWidth: "auto",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <img
                                    src={UploadIcon}
                                    alt="Upload"
                                    style={{ marginRight: "5px", height: 16 }}
                                  />
                                  Upload Document
                                </UploadButton>
                                <UploadButton
                                  onClick={handleViewSummary}
                                  sx={{
                                    textTransform: "none",
                                    borderColor: "#00b3b5",
                                    color: "#00b3b5",
                                    "&:hover": {
                                      borderColor: "#00999a",
                                      bgcolor: "#e0f7fa",
                                    },
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: "8px",
                                    fontSize: "0.8rem",
                                    minWidth: "auto",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <img
                                    src={ViewIcon}
                                    alt="View Summary"
                                    style={{ marginRight: "5px", height: 16 }}
                                  />
                                  View Summary
                                </UploadButton>

                                <IconButton
                                  sx={{ height: "26px" }}
                                  onClick={() =>selectedApp?.partnerStartedJourney===true?handleViewSummary():  handleContinue(selectedApp)}
                                  disabled={isContinueLoading}
                                >
                                  {isContinueLoading ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <CircularProgress
                                        size={14}
                                        sx={{ color: "#1F2233" }}
                                      />
                                      <span>Loading...</span>
                                    </Box>
                                  ) : (
                                    "Continue"
                                  )}
                                </IconButton>
                              </Box>
                            </>
                          )}
                      </Box>

                      {/* === Application Details === */}
                      <CustomDivider />

                      <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                        alignItems={"stretch"}
                        className="card-contaner-section"
                      >
                        <Grid item xs={12} md={7.5}>
                          <Typography className="card-section-hedging">
                            Application Details
                          </Typography>
                          {/* --- Sales Manager Tooltip logic --- */}
                          {(() => {
                            // Only for leadDetailsData-driven cards (partnerStartedJourney)
                            const isLeadDetails =
                              selectedApp?.partnerStartedJourney &&
                              Array.isArray(leadDataArr) &&
                              leadDataArr.length > 0;
                            if (!isLeadDetails) {
                              // fallback: keep old rendering
                              const SalespersonTooltipContent = (
                                <>
                                  {
                                    <Typography
                                      variant="caption"
                                      display="block"
                                    >
                                      Email:{" "}
                                      {selectedApp?.assignedSMEmail || "-"}
                                    </Typography>
                                  }
                                  {
                                    <Typography
                                      variant="caption"
                                      display="block"
                                    >
                                      Mobile:{" "}
                                      {selectedApp?.assignedSMMobileNumber ||
                                        "-"}
                                    </Typography>
                                  }
                                </>
                              );
                              return (
                                <Grid
                                  container
                                  rowSpacing={2}
                                  columnSpacing={4}
                                >
                                  {Object.entries(appDetails || {})
                                    .filter(
                                      ([field]) =>
                                        !skipFields.includes(
                                          field.toLowerCase(),
                                        ),
                                    )
                                    .map(([field, value]: any) => {
                                      // Format the label once
                                      const formattedLabel = field
                                        ?.replace(/[_-]+/g, " ")
                                        .replace(/([A-Z])/g, " $1")
                                        .replace(/\s+/g, " ")
                                        .replace(/^./, (str: any) =>
                                          str.toUpperCase(),
                                        )
                                        .split(" ")
                                        .map(
                                          (word: any) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1),
                                        )
                                        .join(" ")
                                        .trim();

                                      // Check if label contains SM name
                                      const shouldShowTooltip =
                                        formattedLabel.includes(
                                          "Sales Manager",
                                        );

                                      return (
                                        <Grid
                                          item
                                          xs={6}
                                          sm={3}
                                          key={field}
                                          sx={{ textAlign: "left" }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              mb: 0.5,
                                            }}
                                          >
                                            <Typography
                                              className="card-contaner-lable"
                                              sx={{
                                                marginRight: "4px !important",
                                                marginBottom: "0 !important",
                                              }}
                                            >
                                              {formattedLabel}
                                            </Typography>

                                            {shouldShowTooltip && (
                                              <Tooltip title={SalespersonTooltipContent} placement="top-start" arrow>
                                                <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", ml: 1 }}>
                                                  <IconButton
                                                    size="small"
                                                    disableRipple
                                                    sx={{
                                                      p: 0,
                                                      width: '0px !important',
                                                      minWidth: '0px !important',
                                                      height: '0px !important',
                                                      background: "transparent !important",
                                                      "&:hover": {
                                                        background: "transparent !important",
                                                        p: '0px !important',
                                                        width: '0px !important',
                                                        minWidth: '0px !important',
                                                        height: '0px !important',
                                                      },
                                                    }}
                                                  >
                                                    <InfoOutlinedIcon
                                                      sx={{
                                                        fontSize: "14px",
                                                        color: "#a5a3ae",
                                                      }}
                                                    />
                                                  </IconButton>
                                                </Box>
                                              </Tooltip>
                                            )}
                                          </Box>
                                          <Typography
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "4px",
                                            }}
                                          >
                                            <Typography
                                              style={{
                                                fontSize: "13px",
                                                color: "#6F6B7D",
                                              }}
                                            >
                                              {field === "appliedLoanAmount"
                                                ? "₹ "
                                                : ""}
                                            </Typography>

                                            <TruncatedTextWithTooltip
                                              className="card-contaner-value"
                                              text={value}
                                            // limit={isIphoneSE ? 25 : 35}
                                            />
                                          </Typography>
                                        </Grid>
                                      );
                                    })}
                                </Grid>
                              );
                            }

                            // For leadDetailsData-driven cards, use array for label/value rendering
                            // Find sales manager details
                            const salesManagerNameObj = leadDataArr.find(
                              (item: any) => item.name === "salesManagerName",
                            );
                            const salesManagerEmailObj = leadDataArr.find(
                              (item: any) => item.name === "salesManagerEmail",
                            );
                            const salesManagerMobileObj = leadDataArr.find(
                              (item: any) => item.name === "salesManagerMobile",
                            );
                            const salesPersonDetails = {
                              name: salesManagerNameObj?.value || "",
                              email: salesManagerEmailObj?.value || "",
                              mobile: salesManagerMobileObj?.value || "",
                            };
                            const SalespersonTooltipContent = (
                              <>
                                {salesPersonDetails && (
                                  <Typography variant="caption" display="block">
                                    Email: {salesPersonDetails?.email || "-"}
                                  </Typography>
                                )}
                                {salesPersonDetails && (
                                  <Typography variant="caption" display="block">
                                    Mobile: {salesPersonDetails?.mobile || "-"}
                                  </Typography>
                                )}
                              </>
                            );
                            // Filter out unwanted fields and ensure 'salesManagerName' is last
                            let filteredArr = leadDataArr.filter(
                              (item: any) =>
                                !skipFields.includes(item.name.toLowerCase()),
                            );
                            // Add partnerName
                            filteredArr.push({
                              name: "partnerName",
                              label: "Partner Name",
                              value: selectedApp.partnerName,
                            });
                            const salesManagerIdx = filteredArr.findIndex(
                              (item: any) => item.name === "salesManagerName",
                            );
                            if (salesManagerIdx !== -1) {
                              const [salesManagerItem] = filteredArr.splice(
                                salesManagerIdx,
                                1,
                              );
                              filteredArr.push(salesManagerItem);
                            }

                            return (
                              <Grid container rowSpacing={2} columnSpacing={4}>
                                {filteredArr == null ||
                                  filteredArr?.length === 0
                                  ? Array.from({ length: 8 }).map(
                                    (_, index) => (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        key={index}
                                      >
                                        <Skeleton
                                          variant="text"
                                          sx={{ fontSize: "1rem" }}
                                          width="80%"
                                        />
                                        <Skeleton
                                          variant="text"
                                          sx={{ fontSize: "1rem" }}
                                          width="60%"
                                        />
                                      </Grid>
                                    ),
                                  )
                                  : filteredArr.map((item: any, index: any) => {
                                    // Format createdOn date if present
                                    const formattedItem =
                                      item.name === "createdOn" && item.value
                                        ? {
                                          ...item,
                                          value: formatDateToShortMonth(
                                            item.value,
                                          ),
                                        }
                                        : item;
                                    return (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        key={item.label}
                                        sx={{ textAlign: "left" }}
                                      >
                                        <DetailRow
                                          item={formattedItem}
                                          showInfoIcon={
                                            item.label ===
                                              "Sales Manager Name" &&
                                              (salesPersonDetails?.email ||
                                                salesPersonDetails?.mobile)
                                              ? true
                                              : false
                                          }
                                          salespersonTooltipContent={
                                            SalespersonTooltipContent
                                          }
                                        />
                                      </Grid>
                                    );
                                  })}
                              </Grid>
                            );
                          })()}
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={4.5}
                          sx={{ display: "flex", gap: 1.5 }}
                        >
                          <Grid item sx={{}}>
                            <CustomDivider isVertical={true} />
                          </Grid>

                          {(() => {
                            const partnerStartedJourneyFlag =
                              selectedApp?.partnerStartedJourney;

                            return (
                              <>
                                {selectedApp?.isEligibilityChecked !== null && !selectedApp?.isEligibilityChecked ? (
                                  <>
                                    <div
                                      className="right-side-box"
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                          textAlign: "center",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          px: '10px'
                                        }}
                                      >
                                        <Typography
                                          className="right-side-heading"
                                          sx={{ mb: 0 }}
                                        >
                                          {STATUS_MESSAGES?.ELIGIBILITY_CHECK_FAILED}
                                        </Typography>
                                      </Grid>
                                    </div>
                                  </>
                                ) :
                                  selectedApp?.status ===
                                    APP_STATUS.SANCTIONED ? (
                                    <div
                                      className={
                                        (!partnerStartedJourneyFlag &&
                                          normalizedProvisionalOffer === "yes") ||
                                          selectedApp?.status ===
                                          APP_STATUS.SANCTIONED ||
                                          selectedApp?.status ===
                                          APP_STATUS.DISBURSED
                                          ? "right-side-box-provision"
                                          : "right-side-box"
                                      }
                                      style={isXsOrSm ? { width: "100%" } : { width: "100%", minHeight: "170px" }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          mb: 2,
                                        }}
                                      >
                                        <img
                                          src={
                                            !partnerStartedJourneyFlag &&
                                              normalizedProvisionalOffer === "yes"
                                              ? textFile
                                              : LockSquare
                                          }
                                          alt="lock-square"
                                        />
                                        <Typography className="right-side-heading">
                                          {message}
                                        </Typography>
                                      </Box>

                                      <Grid
                                        container
                                        spacing={2}
                                        sx={{ textAlign: "left" }}
                                      >
                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            {partnerStartedJourneyFlag
                                              ? "Loan Amount"
                                              : "Offer loan amount"}
                                          </Typography>
                                          <Typography className="right-side-value">
                                            {formatCurrency(finalLoanAmountValue)}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            Tenure
                                          </Typography>
                                          <Typography className="right-side-value">
                                            {finalMaxTenureValue}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            {partnerStartedJourneyFlag &&
                                              isSanctioned
                                              ? "VAS Amount"
                                              : "Repayment type"}
                                          </Typography>
                                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                              {partnerStartedJourneyFlag && isSanctioned
                                                ? formatCurrency(finalVasAmountValue)
                                                : (shouldShowValue && getRepaymentLabel(breData?.[selectedApp.submissionId]?.Repayment_Type)) || "-"
                                              }
                                            </Typography>

                                            {!partnerStartedJourneyFlag && breData?.[selectedApp.submissionId]?.Repayment_Type && (
                                              <Tooltip
                                                title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>}
                                                arrow
                                                placement="top"
                                                enterTouchDelay={0}
                                                leaveTouchDelay={3000}
                                              >
                                                <InfoOutlined
                                                  sx={{
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "action.active",
                                                    userSelect: "auto",
                                                    WebkitUserSelect: "auto"
                                                  }}
                                                />
                                              </Tooltip>
                                            )}
                                          </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            Currency
                                          </Typography>
                                          <Typography className="right-side-value">
                                            {finalCurrencyValue}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  ) : !partnerStartedJourneyFlag &&
                                    normalizedProvisionalOffer === "no" ? (
                                    <>
                                      <div
                                        className={
                                          selectedApp?.status ===
                                            APP_STATUS.SANCTIONED ||
                                            selectedApp?.status ===
                                            APP_STATUS.DISBURSED
                                            ? "right-side-box-provision"
                                            : "right-side-box"
                                        }
                                        style={{
                                          width: "100%",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          ...(isXsOrSm ? {} : { minHeight: "170px" }),
                                        }}
                                      >
                                        <Grid
                                          container
                                          spacing={2}
                                          sx={{
                                            textAlign: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            px: '10px'
                                          }}
                                        >
                                          <Typography
                                            className="right-side-heading"
                                            sx={{ mb: 0 }}
                                          >
                                            {message}
                                          </Typography>
                                        </Grid>
                                      </div>
                                    </>
                                  ) : selectedApp?.status !==
                                    APP_STATUS.DISBURSED &&
                                    selectedApp?.status !==
                                    APP_STATUS.ELIGIBILITY_FAILED &&
                                    selectedApp?.status !==
                                    APP_STATUS.APPLICATION_REJECTED &&
                                    selectedApp?.status !==
                                    APP_STATUS.APPLICATION_CLOSED &&
                                    selectedApp?.status !==
                                    APP_STATUS.DECLINED_BY_CREDIT ? (
                                    <div
                                      className={
                                        (!partnerStartedJourneyFlag &&
                                          normalizedProvisionalOffer === "yes") ||
                                          selectedApp?.status ===
                                          APP_STATUS.SANCTIONED ||
                                          selectedApp?.status ===
                                          APP_STATUS.DISBURSED
                                          ? "right-side-box-provision"
                                          : "right-side-box"
                                      }
                                      style={isXsOrSm ? { width: "100%" } : { width: "100%", minHeight: "170px" }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          mb: 2,
                                        }}
                                      >
                                        <img
                                          src={
                                            !partnerStartedJourneyFlag &&
                                              normalizedProvisionalOffer === "yes"
                                              ? textFile
                                              : LockSquare
                                          }
                                          alt="lock-square"
                                        />
                                        <Typography className="right-side-heading">
                                          {message}
                                        </Typography>
                                      </Box>

                                      <Grid
                                        container
                                        spacing={2}
                                        sx={{ textAlign: "left" }}
                                      >
                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            {partnerStartedJourneyFlag
                                              ? "Loan Amount"
                                              : "Offer loan amount"}
                                          </Typography>
                                          <Typography className="right-side-value">
                                            {formatCurrency(finalLoanAmountValue)}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            Tenure
                                          </Typography>
                                          <Typography className="right-side-value">
                                            {finalMaxTenureValue}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            {partnerStartedJourneyFlag &&
                                              isSanctioned
                                              ? "VAS Amount"
                                              : "Repayment type"}
                                          </Typography>
                                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                              {partnerStartedJourneyFlag && isSanctioned
                                                ? formatCurrency(finalVasAmountValue)
                                                : (shouldShowValue && getRepaymentLabel(breData?.[selectedApp.submissionId]?.Repayment_Type)) || "-"
                                              }
                                            </Typography>

                                            {!partnerStartedJourneyFlag && breData?.[selectedApp.submissionId]?.Repayment_Type && (
                                              <Tooltip
                                                title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>}
                                                arrow
                                                placement="top"
                                                enterTouchDelay={0}
                                                leaveTouchDelay={3000}
                                              >
                                                <InfoOutlined
                                                  sx={{
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "action.active",
                                                    userSelect: "auto",
                                                    WebkitUserSelect: "auto"
                                                  }}
                                                />
                                              </Tooltip>
                                            )}
                                          </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6}>
                                          <Typography className="right-side-lable">
                                            Currency
                                          </Typography>
                                          <Typography className="right-side-value">
                                            {finalCurrencyValue}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </div>
                                  ) : (
                                    <>
                                      <div
                                        className={
                                          selectedApp?.status ===
                                            APP_STATUS.SANCTIONED ||
                                            selectedApp?.status ===
                                            APP_STATUS.DISBURSED
                                            ? "right-side-box-provision"
                                            : "right-side-box"
                                        }
                                        style={{
                                          width: "100%",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          ...(isXsOrSm ? {} : { minHeight: "170px" }),
                                        }}
                                      >
                                        <Grid
                                          container
                                          spacing={2}
                                          sx={{
                                            textAlign: "center",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            px: '10px'
                                          }}
                                        >
                                          <Typography
                                            className="right-side-heading"
                                            sx={{ mb: 0 }}
                                          >
                                            {message}
                                          </Typography>
                                        </Grid>
                                      </div>
                                    </>
                                  )}
                              </>
                            );
                          })()}
                        </Grid>
                      </Grid>

                      {/* Application Progress */}
                      <CustomDivider />
                      <NextStepBanner
                        status={selectedApp?.status}
                        managerName={selectedApp?.assignedSMName}
                        onResume={() => handleResumeApplication(selectedApp)}
                        isResumeLoading={isResumeLoading}
                        completedSteps={finalSteps.filter(
                          (step: any) => step?.status === "completed" || step?.isCompleted
                        ).length}
                        totalSteps={finalSteps.length}
                      />

                      {/* Application Progress (Desktop Stepper) */}
                      <Grid
                        container
                        spacing={3}
                        className="card-contaner-section"
                      >
                        <ApplicationProgressStepper
                          data={finalSteps}
                          activeStep={activeStep}
                          isLoading={isSliderLoading}
                          partnerStartedJourney={selectedApp?.partnerStartedJourney}
                        />
                      </Grid>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "350px",
              textAlign: "center",
              p: 3,
            }}
            className="card-contaner"
          >
            <Typography
              sx={{ fontSize: "25px", fontWeight: 600, color: "#646464ff" }}
            >
              No Application
            </Typography>
            <Typography
              sx={{
                color: "#6c757d",
                mb: 4,
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              Oops! 😣 You don't have any Existing Applications
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#00b3b5",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#009a9b",
                },
                fontWeight: "600",
                fontSize: "13px",
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: "capitalize",
              }}
              onClick={() => {
                navigate("/application/apply-now");
              }}
            >
              Apply for New Application
            </Button>
          </Box>
        )
      ) : (
        <></>
      )}

      {/* Recent Updates */}
      <Box sx={{mr: isDeviceTypeMobile(isXsOrSm)?1:0}}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={isXsOrSm ? 2 : 5}
      >
        <Typography className="section-heading">Recent Updates</Typography>
        {/* <Typography
          className="section-heading"
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontSize: isXsOrSm ? "14px !important" : "",
            fontWeight: isXsOrSm ? "400 !important" : 600,
          }}
        >
          View all{" "}
          <img
            src={ChevronRight}
            alt="Chevron Right"
            style={{ marginLeft: "5px" }}
          />
        </Typography> */}
      </Box>
      <div className="card-contaner">
        <Box>
          {isRecentUpdatesLoading ? (
            <>
              {Array.from({ length: 3 }).map((_, idx) => (
                <Box key={idx}>
                  <Box display="flex" pr={1} mb={2} gap={1}>
                    <Skeleton
                      variant="circular"
                      width={30}
                      height={30}
                      sx={{ mt: "6px" }}
                    />
                    <Box flexGrow={2}>
                      <Skeleton variant="text" width="60%" height={18} />
                      <Skeleton variant="text" width="80%" height={14} />
                    </Box>
                  </Box>
                  <Skeleton height={1} width="100%" />
                </Box>
              ))}
            </>
          ) : recentUpdates?.length > 0 ? (
            <>
              {recentUpdates?.map((update) => (
                <Box key={update?.id}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between",
                      alignItems: isXsOrSm ? 'flex-start' : "center",
                      mb: 2,
                      width: "100%",
                    }}
                  >
                    {/* Left Side: Avatar + Description */}
                    <Box sx={{ display: "flex", flex: 1, gap: 2, alignItems: "center" }}>
                      <Box>
                        {userProfile?.name ? (
                          <Avatar
                            alt={userProfile?.name ?? undefined}
                            src={userProfile?.name}
                            sx={{ bgcolor: "#00B3B5" }}
                          />
                        ) : (
                          <Avatar />
                        )}
                      </Box>
                      <Typography
                        className="existing-application-des"
                        sx={{ wordBreak: "break-word" }}
                      >
                        {update?.description}
                      </Typography>
                    </Box>

                    {/* Right Side: Date */}
                    <Box
                      sx={{
                        minWidth: "fit-content",
                        ml: { xs: 7, md: 2 },
                        mt: { xs: 0.5, sm: 0 },
                        textAlign: { xs: "left", sm: "right" },
                      }}
                    >
                      <Typography className="dates" sx={{ whiteSpace: "nowrap" }}>
                        {update?.timestamp}
                      </Typography>
                    </Box>
                  </Box>

                  <Box flexGrow={3}></Box>
                  <CustomDivider />
                </Box>
              ))}
            </>
          ) : (
            <>
              <Box sx={{ textAlign: "center" }}>
                <Typography>No recent updates available.</Typography>
              </Box>
            </>
          )}
        </Box>
      </div>
      </Box>
    </Box>
    {isXsOrSm && applications?.[selectedAppIndex]?.isEligibilityChecked !== false && (
      <Box
        sx={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1200,
          px: 3.25,
          py: 2,
          backgroundColor: "#fff",
          boxShadow: "0 -4px 14px rgba(0, 0, 0, 0.14)",
          borderRadius: "16px 16px 0 0",
        }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={() =>
            applications?.[selectedAppIndex]?.partnerStartedJourney === true
              ? handleViewSummary()
              : handleContinue(applications?.[selectedAppIndex])
          }
          disabled={isContinueLoading}
          sx={{
            minHeight: "42px",
            borderRadius: "8px",
            backgroundColor: "#fecd3d",
            color: "#000",
            textTransform: "none",
            fontSize: "15px",
            fontWeight: 700,
            letterSpacing: "0.43px",
            boxShadow: "none",
            "&:hover": { backgroundColor: "#fecd3d", boxShadow: "none" },
          }}
        >
          {isContinueLoading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CircularProgress size={16} sx={{ color: "#1F2233" }} />
              <span>Loading...</span>
            </Box>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
              <span>Continue</span>
              <ArrowForwardIcon sx={{ fontSize: 15, fontWeight: 700 }} />
            </Box>
          )}
        </Button>
      </Box>
    )}
    <Snackbar
      open={callbackSnackbar.open}
      autoHideDuration={4000}
      onClose={() =>
        setCallbackSnackbar((current) => ({ ...current, open: false }))
      }
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
    >
      <Alert
        severity={callbackSnackbar.severity}
        onClose={() =>
          setCallbackSnackbar((current) => ({ ...current, open: false }))
        }
        sx={{ width: "100%" }}
      >
        {callbackSnackbar.message}
      </Alert>
    </Snackbar>
    </Grid>
  );
};;

export default ExistingApplication;
